import { Translations } from "./translations";

export const de: Translations = {
  nav: {
    services: "Dienstleistungen",
    innovation: "Innovation",
    about: "Über uns",
    getInTouch: "Kontakt",
    openMenu: "Navigationsmenü öffnen",
    closeMenu: "Navigationsmenü schließen",
  },
  connectedCareHero: {
    healthForAll: "Gesundheit für alle, ",
    anytime: "Jederzeit",
    anywhere: "Überall",
    fullHeadline: "Gesundheit für alle, Jederzeit Überall",
    subtitle:
      "VIDAVO entwickelt digitale Gesundheitslösungen, die Menschen, Daten und Pflegeteams verbinden, um die alltägliche Gesundheitsversorgung zu verbessern.",
    exploreServices: "Unsere Dienstleistungen entdecken",
    discoverVida24: "Vida24 entdecken",
    keywords: {
      secondOpinion: "Zweitmeinung",
      telemedicine: "Telemedizin",
      smartNutrition: "Intelligente Ernährung",
      selfManagement: "Selbstverwaltung",
      digitalTherapeutics: "Digitale Therapeutika",
      eWellness: "eWellness",
      behaviorChange: "Verhaltensänderung–Achtsamkeit",
      mentalHealth: "Psychische Gesundheit",
    },
  },
  hero: {
    badge: "Digitale Gesundheitsinnovation",
    title: "Ihr digitaler Gesundheits-Experte",
    subtitle:
      "Von der Strategie bis zur vollständigen Implementierung unterstützt VIDAVO Sie in jeder Phase Ihrer digitalen Gesundheitsreise.",
  },
  trustedBy: {
    title: "Das Vida24 Digital-Gesundheits-Ökosystem",
    subtitle:
      "All-in-One-Telegesundheits-Ökosystem für Überwachung, Entscheidungsunterstützung und integrierte Versorgung.",
    description:
      "VIDAVOs All-in-One-Digital-Gesundheits-Ökosystem, das Patienten, medizinische Fachkräfte und Organisationen zusammenbringt. Es ermöglicht kontinuierliche Überwachung durch Wearables und medizinische Geräte, sicheren Datenaustausch und klinische Dashboards, die bessere Entscheidungen und gesündere Leben unterstützen.",
    learnMore: "Mehr über Vida24 erfahren",
    faqTitle: "Häufig Gestellte Fragen",
    faqSubtitle: "Erhalten Sie Antworten auf häufige Fragen zu VIDAVOs digitalen Gesundheitslösungen und -diensten.",
    faqs: {
      question1: "Was unterscheidet VIDAVO in der digitalen Gesundheit?",
      answer1:
        "VIDAVO kombiniert tiefgreifende Gesundheitsexpertise mit zertifizierter Technologie und bietet modulare Lösungen, die klinisch sicher, benutzerfreundlich und skalierbar sind.",
      question2: "Was ist Vida24?",
      answer2:
        "Vida24 ist unser führendes digitales Gesundheitsökosystem. Es verbindet Patienten, Fachkräfte und Organisationen durch Fernüberwachung, sicheren Datenaustausch und intelligente Dashboards.",
      question3: "Sind die Lösungen von VIDAVO zertifiziert?",
      answer3:
        "Ja. Vida24 ist CE-zertifiziert gemäß der Medizinprodukterichtlinie (MDD) und befindet sich derzeit im Zertifizierungsprozess gemäß der EU-Medizinprodukteverordnung (MDR). Alle VIDAVO-Prozesse und -Produkte sind DSGVO-konform und werden von ISO-zertifizierten Qualitäts- und Sicherheitsstandards unterstützt.",
      question4: "Mit wem arbeiten Sie zusammen?",
      answer4:
        "Wir arbeiten mit Krankenhäusern, Gesundheitsdienstleistern, Forschungseinrichtungen, Kommunen und Industriepartnern zusammen, die zuverlässige digitale Gesundheitslösungen implementieren möchten.",
      question5: "Wie unterstützen Sie Kunden nach der Implementierung?",
      answer5:
        "Wir bieten Schulungen, technische Unterstützung und kontinuierliche Updates, um sicherzustellen, dass die Lösungen zuverlässig, sicher und effektiv bleiben.",
      question6: "Kann VIDAVO neue Apps oder Software über Vida24 hinaus entwickeln?",
      answer6:
        "Absolut. Wir bieten Vida24 als SaaS an, bieten White-Label-Lösungen für Partner und entwickeln maßgeschneiderte Apps, die auf die Bedürfnisse der Kunden zugeschnitten sind.",
    },
  },
  rdMenu: {
    researchOnDemand: "Forschung on Demand",
    rdPortfolio: "F&E Projektportfolio",
    buildingInnovation: "Innovation Aufbauen",
    digitalTransformation: "Digitale Transformation",
  },
  digitalTransformation: {
    badge: 'DIGITALE TRANSFORMATION',
    title: 'Vida24',
    subtitle: 'Projektcode: 108682',
    projectTitle: 'Fortschrittliche Telemedizin & Intelligenz-Upgrade',
    projectTitleContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    briefDescription: 'Kurzbeschreibung',
    briefDescriptionContent: 'Investition in die Skalierbarkeit und hohe Verfügbarkeit von Vida24 mit dem Ziel der kommerziellen Expansion in Europa.',
    investmentPlanBudget: 'Investitionsplan Budget',
    investmentPlanBudgetContent: '€430.100,00',
    investmentPlanEuFunding: 'EU-Förderung',
    investmentPlanEuFundingContent: '€210.875,00',
    investmentPlanDisclaimer: 'Dieses Projekt wird im Rahmen des Programms «Entwicklung digitaler Produkte und Dienstleistungen» des Nationalen Wiederaufbau- und Resilienzplans Griechenland 2.0 durchgeführt, finanziert von der Europäischen Union – NextGenerationEU',
    logoAlt: 'Griechenland 2.0 Nationaler Wiederaufbau- und Resilienzplan - Finanziert von der Europäischen Union NextGenerationEU',
  },
  buildingInnovation: {
    badge: "INNOVATION AUFBAUEN",
    title: "Die Gesundheitsversorgung von morgen",
    subtitle:
      "Innovation aufbauen bedeutet, heute an den Lösungen zu arbeiten, die das Gesundheitswesen morgen brauchen wird. Durch unsere Forschungsbemühungen erforschen wir neue Technologien, validieren neue Methoden und schaffen gemeinsam mit akademischen, klinischen und industriellen Partnern neue Wege. Wir heißen Konsortien und Interessengruppen willkommen, die Teil dieser Reise sein und gemeinsam die Zukunft der Gesundheit gestalten möchten.",
    focusAreasTitle: "Innovationsschwerpunkte",
    focusAreasSubtitle:
      "Erkunden Sie unsere hochmodernen Forschungsbereiche, die die Gesundheitslandschaft von morgen prägen",
    focusAreas: [
      "Künstliche Intelligenz für Klinische Entscheidungsunterstützung",
      "KI für Bevölkerungs- und Öffentliche Gesundheit",
      "6G und IoT der Nächsten Generation",
      "Digitale Zwillinge im Gesundheitswesen",
      "Extended Reality (VR/AR/MR)",
      "Digitale Biomarker und Fernerkundung",
      "Nachhaltige und Grüne Gesundheitstechnologie",
      "Dateninteroperabilität und Vertrauen",
    ],
    partnerTitle: "Partnerschaft mit Uns",
    partnerSubtitle:
      "Treten Sie unserem Ökosystem von Innovationspartnern bei, die die Zukunft der Gesundheitsversorgung gestalten",
    partners: {
      academic: {
        title: "Akademische Partner",
        description: "Universitäten und Forschungseinrichtungen, die bahnbrechende Entdeckungen vorantreiben",
      },
      healthcare: {
        title: "Gesundheitsdienstleister",
        description: "Krankenhäuser und Kliniken, die reale Lösungen umsetzen",
      },
      industry: {
        title: "Branchenführer",
        description: "Technologieunternehmen und Gesundheitsinnovatoren",
      },
    },
  },
  researchOnDemand: {
    badge: "F&E LÖSUNGEN",
    title: "Forschung auf Anfrage",
    subtitle: "Fragen in Ergebnisse verwandeln",
    description:
      "Forschung wird wertvoll, wenn sie echte Bedürfnisse beantwortet. Bei Vidavo entwerfen und führen wir Studien durch, die praktische Erkenntnisse für Gesundheitswesen, Industrie und Politik generieren. Unser Ansatz kombiniert wissenschaftliche Genauigkeit mit einem klaren Fokus auf Anwendbarkeit und stellt sicher, dass jedes Projekt Ergebnisse liefert, die Entscheidungen leiten, neue Lösungen gestalten oder Produkte validieren können.",
    whatWeOffer: "Was wir anbieten",
    services: [
      {
        title: "Maßgeschneidertes Studiendesign",
        description:
          "Von kleinen Pilotstudien bis zu multizentrischen Studien planen wir Untersuchungen, die zu den Zielen und Ressourcen unserer Partner passen.",
      },
      {
        title: "Klinische Validierung",
        description:
          "Expertise in Protokollen zur Bewertung von Sicherheit, Leistung und Benutzerfreundlichkeit digitaler Gesundheitstechnologien in realen Umgebungen.",
      },
      {
        title: "Nutzer- und Marktforschung",
        description:
          "Erfassung und Analyse von Feedback von Patienten, Klinikern und Gesundheitsorganisationen zur Produktentwicklung.",
      },
      {
        title: "Datenmanagement und Analytik",
        description:
          "Sichere Infrastrukturen zum Sammeln, Verarbeiten und Interpretieren von Gesundheitsdaten mit Transparenz und Compliance.",
      },
      {
        title: "Bewertungsrahmen",
        description:
          "Entwicklung von KPIs und Ergebnismaßen, die den Wert in klinischen, wirtschaftlichen oder sozialen Begriffen demonstrieren.",
      },
    ],
    globalNetwork: {
      badge: "WELTWEITE PRÄSENZ",
      title: "Globales Forschungsnetzwerk",
      description:
        "Unsere Forschungsprojekte erstrecken sich über mehrere Länder und schaffen ein umfassendes Netzwerk von Gesundheitsinnovation und wissenschaftlicher Zusammenarbeit, das die globale Gesundheitsförderung vorantreibt.",
    },
    trackRecord: {
      title: "Unsere Erfolgsbilanz",
      description:
        "In den letzten zwei Jahrzehnten haben wir europäische und nationale Forschungsprojekte unterstützt, mit Universitäten und Krankenhäusern in mehreren Ländern zusammengearbeitet und mit privaten Unternehmen neue Gesundheitstechnologien vom Konzept bis zur Implementierung gebracht. Unsere Rolle reichte von wissenschaftlicher Koordination und klinischen Studien bis zur Technologieentwicklung und Folgenabschätzung.",
    },
    stats: [
      { label: "Jahre Erfahrung" },
      { label: "Europäische und nationale Forschungsprojekte" },
      { label: "Akademische und klinische Partner weltweit" },
      { label: "Länder mit Projektimplementierungen" },
    ],
  },
  euNationalProjects: {
    badge: "EU/NATIONALE PROJEKTE",
    title: "Aktuelles Projektportfolio",
    subtitle: "Unser umfassendes Portfolio an abgeschlossenen und laufenden Forschungsprojekten in ganz Europa.",
    projectDescriptions: {
      marissa:
        "Ein Horizon 2020-Projekt, das eine digitale Plattform zur Verbesserung des Managements von Typ-II-Diabetes und Sarkopenie bei älteren Erwachsenen durch personalisierte Pflege, Fernüberwachung und Patientenermächtigung entwickelt.",
      raise:
        "Ein Horizon 2020-Projekt, das Tele-Rehabilitationslösungen entwickelt, die es Patienten in abgelegenen Gebieten ermöglichen, kontinuierliche Pflege zu erhalten und chronische Erkrankungen über das Vida24-System, verbundene medizinische Geräte und Fernunterstützung zu verwalten.",
      valueCare:
        "Ein Horizon 2020-Projekt, das eine integrierte digitale Lösung zur Unterstützung älterer Menschen mit chronischen Erkrankungen bietet, die Gesundheits- und Sozialdienste kombiniert, um Lebensqualität und Pflegeeffizienz zu verbessern.",
      intelliot:
        "Ein Horizon 2020-Projekt, das IoT-Lösungen der nächsten Generation für Gesundheitswesen, Landwirtschaft und Fertigung entwickelt, wobei Vidavo zur patientenzentrierten digitalen Unterstützung und Ferngesundheitsüberwachung beiträgt.",
      inspect:
        "Ein von der EU und nationalen Ressourcen kofinanziertes Projekt, das intelligente Krankenhausbetten mit eingebetteten Sensoren entwickelt, um Patienten kontinuierlich zu überwachen, frühe Gesundheitsrisiken zu erkennen und Komplikationen wie Druckgeschwüre zu verhindern.",
      pat: "Ein im Rahmen des griechischen Operationellen Programms «Wettbewerbsfähigkeit und Unternehmertum» finanziertes Projekt, das ein digitales System zur kontinuierlichen Überwachung und Früherkennung allergischer Atemwegserkrankungen entwickelt hat, das Patienten und Ärzten hilft, Symptome zu verwalten und die Lebensqualität zu verbessern.",
      intelTriage:
        "Ein Projekt, das ein intelligentes Triage- und Überwachungssystem für Krankenhaus-Notaufnahmen entwickelt, das Biosensoren und Entscheidungsunterstützungstools verwendet, um die Pflege zu priorisieren und Patienten während ihrer ersten 24 Stunden nach Aufnahme zu verfolgen.",
      liver3d:
        "Ein von der EU und nationalen Ressourcen kofinanziertes Forschungsprojekt, das 3D-gedruckte Organmodelle entwickelt, um chirurgische Planung und Schulung zu unterstützen und die Präzision und Sicherheit medizinischer Verfahren zu verbessern.",
      sefac:
        "Ein von der EU finanziertes Projekt, das Prävention und Selbstmanagement chronischer Krankheiten fördert, indem es Bürger, Gesundheitsdienstleister und Freiwillige in gemeinschaftsbasierte Aktivitäten und IKT-unterstützte Programme in vier europäischen Pilotregionen einbezieht.",
      cyberCare:
        "Ein von der EU und nationalen Ressourcen kofinanziertes Projekt, das ein Cybersicherheitssystem zum Schutz von Gesundheitsnetzwerken und verbundenen medizinischen Geräten entwickelt, validiert durch ein Pilotprojekt für Schwangerschaftsfernbetreuung in Griechenland.",
      im: "Eine digitale Plattform zur Verwaltung von Onkologiepatienten und Chemotherapieprotokollen, die Automatisierung, Geschwindigkeit und Sicherheit in allen Behandlungsphasen bietet. Das Projekt «IM» wurde im Rahmen der Aktion «Investitionspläne für Innovation» des Programms «Zentralmakedonien», PARD 2021-2027», umgesetzt, das von der Europäischen Union und Griechenland kofinanziert wird",
      smartcare:
        "Ein europäisches Projekt, das IKT-unterstützte Pflegepfade entwickelt hat, um Gesundheits- und Sozialdienste zu integrieren, pilotiert in zehn Regionen in Europa, um die Koordination und Bereitstellung bürgerorientierter Pflege zu verbessern.",
      evolve2care:
        "Gefördert von der Europäischen Union, treibt EVOLVE2CARE die HealthTech-Erprobung voran, um die Zusammenarbeit zwischen Living Labs und Innovatoren in der Übergangsversorgung zu stärken. Das Projekt unterstützt die Skalierung der Vida24-Plattform von VIDAVO, einer CE-zertifizierten digitalen Gesundheitslösung für das Management chronischer Krankheiten, durch ein nicht-klinisches Validierungspilotprojekt. In Zusammenarbeit mit dem Good Tech Living Lab in Rumänien konzentriert es sich auf die reale Validierung von Benutzerfreundlichkeit, Patientenengagement, Eignung für klinische Arbeitsabläufe und ethischen Einsatz.",
      cyberSuite:
        "CyberSuite ist ein Digital-Europe-Projekt, das KMU bei der Einführung fortschrittlicher Cybersicherheitslösungen über eine integrierte Security-as-a-Service-Plattform und einen Marketplace unterstützt. VIDAVO leitet den Anwendungsfall Digital Health über seine Vida24®-Plattform und unterstützt die Validierung der CyberSuite-Lösungen in einer realen Gesundheitsumgebung, mit Schwerpunkt auf Cybersicherheits-Monitoring, Schwachstellenbewertung und Stärkung der Cyber-Resilienz von Telegesundheitsplattformen.",
      cerebris:
        "CEREBRIS ist ein EIC-Pathfinder-Projekt, das ein sicheres und erklärbares KI-Ökosystem für die Schlaganfallversorgung und das Management neurologischer Erkrankungen entwickelt. Durch die Kombination klinischer Daten, Bildgebung des Gehirns, Biosignale und fortschrittlicher KI-Modelle unterstützt das Projekt eine stärker personalisierte Rehabilitation und Vorhersage der Genesung. VIDAVO trägt als Partner für die digitale Gesundheitsplattform bei und unterstützt Interoperabilität, Datenerfassung und Integration im gesamten CEREBRIS-Ökosystem.",
      default:
        "Ein innovatives Gesundheitstechnologie-Projekt, das zur digitalen Gesundheitstransformation und zur Verbesserung der Patientenversorgung beiträgt.",
    },
    seeMore: "Mehr erfahren",
    tapToFlip: "Tippen für Details",
  },
  aboutMenu: {
    vidavoEU: 'Vidavo EU',
    vidavoIndia: 'VIDAVO Asien',
    vidavoThroughTime: "Vidavo im Laufe der Zeit",
    whyUs: "Warum Wir",
    investorRelations: "Investor Relations",
    careers: "Karriere",
    vida24HomeCare: 'Vida24 für die häusliche Pflege',
  },
  vidavoMiddleEast: {
    pageTitle: 'VIDAVO Middle East | Connected Care & KI-gestützte digitale Gesundheit',
    metaDescription: 'VIDAVO bringt vernetzte Versorgung und KI-gestützte digitale Gesundheitslösungen in den Nahen Osten – über die VIDA24-Plattform und KI-Gesundheitsentwicklungsdienstleistungen.',
    badge: 'VIDAVO Naher Osten',
    aiBadge: 'KI',
    heroTitle: 'VIDAVO – Digitale Gesundheit durch vernetzte Versorgung und KI-Innovation voranbringen',
    heroSubtitle: 'Gesundheit für alle, jederzeit, überall',
    heroLead: 'Gesundheitsversorgung durch vernetzte Versorgung transformieren',
    heroText: 'VIDAVO ist ein Digital-Health-Unternehmen, das die Versorgung mit innovativen Connected-Care-Lösungen verändert. Unsere Mission ist es, Gesundheitsversorgung zugänglicher, effizienter und patientenzentrierter zu machen – jederzeit und überall.',
    platformTitle: 'Die digitale Gesundheitsplattform VIDA24',
    platformText: 'Im Zentrum unseres Ökosystems steht VIDA24, eine modulare und skalierbare Digital-Health-Plattform für Fernüberwachung von Patienten, Telemedizin, Management chronischer Erkrankungen, virtuelle Versorgungsdienste und integrierte Versorgungsprozesse.\n\nIn einer einheitlichen Umgebung verbindet VIDA24 Gesundheitsfachkräfte, Patienten und Medizingeräte und ermöglicht Echtzeitkommunikation, Monitoring und klinische Entscheidungsunterstützung.',
    platformCta: 'vida24.eu besuchen',
    aiTitle: 'KI-gestützte Gesundheitslösungen',
    aiText1: 'Künstliche Intelligenz wird zu einem festen Bestandteil der modernen Gesundheitsversorgung, und VIDAVO integriert KI-Funktionen aktiv in seine Lösungen. KI-Technologien unterstützen Datenanalyse, Risikobewertung, Patientenmonitoring, klinische Entscheidungsfindung und Prozessoptimierung und helfen Gesundheitsorganisationen, Effizienz und Behandlungsergebnisse zu verbessern.',
    aiText2: 'Über Plattformlösungen hinaus bietet VIDAVO auch KI-Entwicklungsdienste für das Gesundheitswesen an und unterstützt Organisationen, Leistungserbringer und Partner bei Konzeption, Entwicklung und Integration KI-gestützter digitaler Gesundheitsanwendungen. Durch die Verbindung von Gesundheitsexpertise, digitaler Innovation und fortschrittlichen Technologien beschleunigen wir ihre digitale Transformation.',
    futureTitle: 'Die Zukunft der digitalen Gesundheit gestalten',
    futureText: 'Mit umfangreicher Erfahrung in digitaler Gesundheit, Telemedizin und vernetzter Versorgung unterstützt VIDAVO Gesundheitssysteme und Organisationen dabei, intelligentere, proaktivere und zugänglichere Leistungen zu erbringen.',
    ctaTitle: 'Lassen Sie uns vernetzte Versorgung gemeinsam gestalten',
    ctaText: 'Sprechen Sie mit unserem Team über Digital-Health- und KI-Initiativen im Nahen Osten.',
    ctaButton: 'Kontaktieren Sie uns',
    readInArabic: 'Read this page in Arabic',
    tapToZoom: 'Zum Zoomen tippen',
    heroImageAlt: 'Gesundheitsfachkraft mit Tablet in einer digitalen vernetzten Versorgungsumgebung.',
    applicationImageAlt: 'VIDA24-App mit Vitalparametern, Pflegeplan und Gesundheits-Fernüberwachung.',
  },
  vidavoIndia: {
    pageTitle: 'VIDAVO Asien | Connected Care & digitale Gesundheit in Indien',
    metaDescription: 'VIDAVO Asia bringt über 25 Jahre Erfahrung in digitaler Gesundheit und die VIDA24-Plattform nach Indien – bewährte Technologie trifft lokale Expertise.',
    badge: 'VIDAVO Asia',
    heroTitle: 'Connected Care nach Indien bringen',
    heroText: 'VIDAVO Asia bringt die über 25-jährige Erfahrung von VIDAVO in digitaler Gesundheit und die VIDA24-Plattform nach Indien und verbindet international bewährte Technologie mit lokaler Expertise, um die digitale Transformation des Gesundheitswesens zu unterstützen.',
    heroImageAlt: 'Die digitale Gesundheitsplattform VIDA24 verbindet Versorgung in ganz Indien',
    whoWeAreTitle: 'VIDAVO Asia: Globale Erfahrung, lokale Expertise',
    whoWeAreText: 'VIDAVO Asia vertritt VIDAVO S.A. in Indien und bringt über 25 Jahre Erfahrung in digitaler Gesundheit und Connected Care in einen der am schnellsten wachsenden Gesundheitsmärkte der Welt.\n\nIn Partnerschaft mit Mc&Me Techserve Pvt. Ltd. verbindet VIDAVO Asia international bewährte Digital-Health-Lösungen mit lokaler Expertise, um die wachsenden Anforderungen von Gesundheitsorganisationen in ganz Indien zu erfüllen.',
    platformLabel: 'VIDA24',
    platformTitle: 'Eine Plattform. Vielfältige Möglichkeiten.',
    platformText: 'VIDA24 ist die modulare und interoperable Digital-Health-Plattform von VIDAVO, die Patienten, Gesundheitsfachkräfte und Gesundheitsorganisationen entlang des gesamten Versorgungskontinuums verbindet.\n\nVon der Fernüberwachung von Patienten und Telemedizin bis zum Management chronischer Erkrankungen und zur Versorgungskoordination ermöglicht VIDA24 eine vernetztere, effizientere und patientenzentriertere Versorgung.',
    demoButton: 'Demo anfordern',
    solutionsTitle: 'Unsere Lösungen',
    solutions: [
      { title: 'Connected Care', description: 'Kontinuierliche und koordinierte Versorgung über alle Settings hinweg.' },
      { title: 'Fernüberwachung von Patienten', description: 'Vernetztes Monitoring jenseits der Krankenhausmauern.' },
      { title: 'Telemedizin & Virtuelle Versorgung', description: 'Fernzugang zu Gesundheitsfachkräften und -diensten.' },
      { title: 'Management chronischer Erkrankungen', description: 'Kontinuierliche Unterstützung bei Langzeiterkrankungen.' },
      { title: 'Versorgungskoordination', description: 'Verbindung multidisziplinärer Teams entlang der gesamten Patientenreise.' },
    ],
    innovationTitle: 'KI-gestützte digitale Innovation',
    innovationText: 'VIDA24 umfasst KI-Funktionen für intelligente Datenanalyse, Risikoerkennung, Prozessoptimierung und fortschrittliche Entscheidungsunterstützung — zur Unterstützung der Gesundheitsfachkräfte, mit dem Menschen im Mittelpunkt der Versorgung.',
    experienceTitle: 'Internationale Erfahrung. Lokale Perspektive.',
    experienceText: 'Seit über 25 Jahren arbeitet VIDAVO mit Krankenhäusern, Gesundheitsorganisationen, Forschungseinrichtungen, Industriepartnern und Behörden zusammen, um innovative Digital-Health-Lösungen zu entwickeln und bereitzustellen.\n\nÜber VIDAVO Asia wird diese Erfahrung mit lokaler Expertise kombiniert, um die wachsenden Anforderungen des indischen Gesundheitsökosystems zu unterstützen.',
    discoverTitle: 'Entdecken Sie VIDAVO Asia',
    discoverText: 'Erfahren Sie, wie VIDAVO Asia und unsere Connected-Care-Lösungen Gesundheitsorganisationen in Indien unterstützen können.',
    contactButton: 'Kontaktieren Sie unser Team',
    ctaEmail: 'india.remotecare@vidavo.eu',
  },
  vidavoEU: {
    badge: 'EU-PROJEKTE',
    title: 'Vidavo – Gesundheitsversorgung jederzeit und überall, jetzt auch in Europa!',
    titlePart1: 'Vidavo – Gesundheitsversorgung jederzeit und überall,',
    titleHighlight: 'jetzt auch in Europa!',
    subtitle: 'Mit Vidavo EU in Lüttich, Belgien, machen wir den ersten Schritt unserer internationalen Expansion und bringen unsere digitalen Gesundheitslösungen zu Gesundheitsorganisationen in ganz Europa.',
    ctaButton: 'Kontakt – Zusammenarbeit mit Vidavo EU',
    section1Title: 'Warum Lüttich? Warum Europa?',
    section1Intro: 'Lüttich ist ein strategischer Punkt für Vidavos europäisches Wachstum und bietet direkten Zugang zu neuen Möglichkeiten der Zusammenarbeit im Gesundheitswesen sowie ein unterstützendes Umfeld für digitale Gesundheitsinnovationen. Mit Vidavo EU legen wir die Grundlagen für unsere internationale Präsenz und schaffen neue Perspektiven für Partnerschaften mit europäischen Gesundheitsorganisationen, basierend auf folgenden Säulen.',
    section1Cards: {
      card1Title: 'Entwicklung von Kooperationen und Netzwerken',
      card1Desc: '',
      card2Title: 'Bereitstellung von Vidavo – Healthcare Anytime Anywhere Lösungen in neuen Ländern',
      card2Desc: '',
      card3Title: 'Internationale Gesundheitsinitiativen',
      card3Desc: '',
    },
    section2Title: 'Vidavo EU Büros',
    section2Subtitle: 'Unser neuer europäischer Standort',
    section2AddressLabel: 'Adresse:',
    section2Address: 'Quai sur-Meuse 19, 4000 Lüttich, Belgien',
    section2EmailLabel: 'E-Mail:',
    section2Email: 'VidavoEU@vidavo.eu',
    section2Footer: 'Das Büro in Lüttich ist nun Teil des Vidavo-Standortnetzwerks und dient als Ausgangspunkt für die europaweite Präsenz des Unternehmens.',
    vida24Title: 'Vida24: Ein vollständiges digitales Gesundheitsökosystem',
    vida24Intro: 'Im Herzen der Vidavo-Lösungen liegt Vida24, ein umfassendes digitales Gesundheitsökosystem für Fernversorgung und klinisches Workflow-Management, das unterstützt:',
    vida24Benefits: [
      'Bessere Organisation und Ablauf medizinischer Verfahren',
      'Verbesserte Kommunikation zwischen Gesundheitsfachkräften und Patienten',
      'Sicherer und sofortiger Zugang zu Gesundheitsinformationen'
    ],
    vida24Closing: 'Mit Vida24 ermöglichen wir zugänglichere Gesundheitsdienste – jederzeit, überall – mit den Menschen im Mittelpunkt.',
    euroCollabTitle: 'Aufbau neuer europäischer Kooperationen',
    euroCollabDescription: 'Vidavo EU stärkt unsere Präsenz in Europa durch gezielte Partnerschaften, den Einsatz digitaler Gesundheitstechnologien und Synergien mit Gesundheits- und Technologieorganisationen. Das Unternehmen erweitert bereits sein Netzwerk von Kooperationen auf dem europäischen Markt.',
    euroCollabNote: 'Strategische Partnerschaft mit FHC+P GmbH',
    getInTouchTitle: 'Kontaktieren Sie Vidavo EU',
    getInTouchDescription: 'Sind Sie eine Gesundheitsorganisation, Institution oder ein Unternehmen, das an Zusammenarbeit oder internationalen Entwicklungsmöglichkeiten interessiert ist?',
    getInTouchSubtext: 'Kontaktieren Sie uns, um Möglichkeiten für Projekte, Partnerschaften oder Pilotimplementierungen zu erkunden.',
    getInTouchCTA: 'Kontakt – Mit Vidavo EU zusammenarbeiten',
  },
  vidavo: {
    badge: "UNTERNEHMENSGESCHICHTE",
    title: "VIDAVO im Laufe der Zeit",
    subtitle:
      "Von unserer Gründung im Jahr 2002 bis zu unserer weltweiten Expansion heute, erkunden Sie die Meilensteine, die VIDAVOs Weg zur Revolution der digitalen Gesundheitsversorgung geprägt haben.",
    timeline: {
      event2025: "Kapital aufgebracht – Unser Partner-Ökosystem wird weltweit aufgebaut",
      event2024: "Vida24 InsurTech",
      event2023: "KI-gestützte Patientenaufklärung und -schulung",
      event2021: "Vida24 Intelligentes Triage-Unterstützungssystem",
      event2020: "Vida24 als eine der führenden Gesundheitsplattformen weltweit anerkannt",
      event2019: "Expansion über die EU hinaus",
      event2015: "Patent: Interaktive Plattform für Alzheimer-Krankheit",
      event2014: "Vida24-Software als Medizinprodukt zertifiziert",
      event2011: "Patent: GPS-Panikknopf-Armband",
      event2010: "An der Euronext Athens Alternativer Markt (ΕΝ.Α. Growth) gelistet, Kapital durch Privatplatzierung aufgebracht",
      event2007: "Patent: IoT-Medizinprodukt",
      event2005: "Seed-Kapital von Thermi SA aufgebracht, kommerzieller Start von Vida24 (Mobinet Wellness)",
      event2002: "GmbH gegründet von Dr. Pantelis Angelidis, Elektroingenieur",
    },
    buildingFuture: {
      title: "Die Zukunft Gestalten",
      description:
        "Unsere Reise geht weiter, während wir die Grenzen der digitalen Gesundheitsinnovation erweitern und Patienten und Anbieter weltweit durch fortschrittliche Technologie und mitfühlende Pflegelösungen verbinden.",
    },
  },
  whyUs: {
    badge: "WARUM UNS WÄHLEN",
    title: "Warum Uns Wählen",
    subtitle:
      "Entdecken Sie, was uns in der digitalen Gesundheitsbranche auszeichnet durch unsere bewährte Expertise, unser Engagement für Exzellenz und unsere unerschütterliche Hingabe zur Innovation.",
    advantages: [
      {
        title: "Expertise",
        description:
          "Unser Team vereint wissenschaftliches Wissen, technische Fähigkeiten und eine unternehmerische Denkweise, um qualitativ hochwertige Dienstleistungen von der Implementierung bis zur langfristigen Unterstützung zu liefern.",
      },
      {
        title: "Über 25 Jahre Erfahrung",
        description:
          "Wir gestalten die digitale Gesundheit seit über zwei Jahrzehnten und bringen Forschungserkenntnisse in reale e/mHealth-Lösungen ein.",
      },
      {
        title: "Akkreditierungen",
        description:
          "Unsere Abläufe folgen international anerkannten Standards für Qualitätsmanagement, Medizinproduktsicherheit, Laborpraxis, Anti-Korruptions-Compliance und Datenschutz-Informationssicherheit, was unser Engagement widerspiegelt, digitale Gesundheitslösungen mit dem höchsten Maß an Vertrauen und Zuverlässigkeit aufzubauen.",
      },
      {
        title: "Zertifizierte Lösungen",
        description:
          "Die Vida24-Suite ist nach MDD 93/42 EWG als CE-Klasse IIa zertifiziert und erfüllt strenge europäische regulatorische Anforderungen.",
      },
      {
        title: "Datenschutz",
        description:
          "Wir sind bei der Hellenischen Datenschutzbehörde registriert und vollständig DSGVO-konform, wodurch sensible persönliche Gesundheitsinformationen geschützt werden.",
      },
      {
        title: "Sicherheit",
        description:
          "Unsere Plattformen werden auf ISO 27001-konformen Infrastrukturen gehostet, mit redundanten Konfigurationen für Zuverlässigkeit und Widerstandsfähigkeit.",
      },
    ],
    unGlobalCompact: {
      title: "Engagement für globale Prinzipien",
      description:
        "Wir sind stolzer Teilnehmer des UN Global Compact und richten unsere Strategie und Geschäftstätigkeit an dessen zehn Prinzipien zu Menschenrechten, Arbeit, Umwelt und Korruptionsbekämpfung aus. Dieses Engagement spiegelt unser Bekenntnis zu verantwortungsvollen Geschäftspraktiken und nachhaltiger Entwicklung wider und stellt sicher, dass unsere Innovation zu positiven globalen Auswirkungen beiträgt.",
      pillars: {
        humanRights: "Menschenrechte",
        labour: "Arbeit",
        environment: "Umwelt",
        antiCorruption: "Anti-Korruption",
      },
    },
    finalStatement: {
      title: "Warum uns vertrauen",
      description:
        "Unsere Lösungen sind zertifiziert, wissenschaftlich validiert, umfassend im großen Maßstab getestet, marktbewährt und bereits in verschiedenen Geschäftsumgebungen im Einsatz, vertraut von einer breiten Palette von Stakeholdern.",
    },
  },
  scrollCarousel: {
    steps: {
      step1: {
        title: "Ihr vertrauenswürdiger Experte für Digitale Gesundheit",
        description: "Evidenzbasierte digitale Gesundheitsdienste mit realen Auswirkungen.",
      },
      step2: {
        title: "Beratung",
        description: "Erkundung, Bedarfsanalyse und klarer digitaler Gesundheits-Fahrplan.",
      },
      step3: {
        title: "Design",
        description: "Menschzentrierte UX und klinische Workflows.",
      },
      step4: {
        title: "Entwickeln / Integrieren",
        description: "Interoperable Module und sichere Integrationen mit bestehenden Systemen.",
      },
      step5: {
        title: "Anpassen / SaaS",
        description: "Konfigurierbare Funktionen und skalierbare Cloud-Bereitstellung.",
      },
      step6: {
        title: "Ausbildung",
        description: "Praktische Schulung für Kliniker, Administratoren und Endbenutzer.",
      },
      step7: {
        title: "Support",
        description: "Kontinuierlicher SLA-Support, Überwachung und Updates.",
      },
      step8: {
        title: "Skalierung",
        description: "Vom Pilotprojekt zur Produktion mit Governance und KPIs.",
      },
    },
  },
  collaboratorsCarousel: {
    title: "Unsere Produkte",
    subtitle: "Kern-VIDAVO-Lösungen, die das Rückgrat unseres digitalen Gesundheitsökosystems bilden.",
    products: {
      vida24: "Verbundenes Pflege-Dashboard",
      vida24Healthcare: "Zweitmeinung für Allgemeinärzte",
      vida24Monitoring: "Patientengesundheitsmanagement",
      vidAware: "Smartwatch-Integration",
      vidATrack: "Notfall- und Standortverfolgung",
      vida24Marine: "Telemedizin-Support für Kreuzfahrtschiffe",
      vida: "Therapieunterstützung",
      vida24Vet: "Veterinärgesundheitsmanagement",
    },
  },
  processFlow: {
    steps: {
      step1: {
        title: "Beratung",
        description:
          "Wir beginnen damit, Ihre Bedürfnisse zu verstehen, Ziele zu definieren und eine klare digitale Gesundheitsstrategie zu gestalten.",
      },
      step2: {
        title: "Design",
        description:
          "Wir verwandeln Anforderungen in benutzerzentrierte Designs und gewährleisten von Anfang an Benutzerfreundlichkeit, klinische Sicherheit und Konformität.",
      },
      step3: {
        title: "Entwickeln & Integrieren",
        description:
          "Wir entwickeln zuverlässige digitale Gesundheitslösungen und verbinden sie mit bestehenden IT-Infrastrukturen, medizinischen Geräten und Krankenhaussystemen.",
      },
      step4: {
        title: "Anpassen / SaaS / White Label",
        description:
          "Wir liefern Lösungen als SaaS, bieten White-Label-Bereitstellungen für Partner oder passen Apps für spezifische Arbeitsabläufe an.",
      },
      step5: {
        title: "Ausbildung",
        description:
          "Wir bieten Schulungen für medizinisches Fachpersonal und Mitarbeiter an und gewährleisten so eine selbstbewusste Einführung und tägliche Nutzung der neuen digitalen Tools.",
      },
      step6: {
        title: "Support",
        description:
          "Wir bieten kontinuierlichen technischen Support, um Systeme zuverlässig, sicher und kontinuierlich aktualisiert zu halten.",
      },
      step7: {
        title: "Skalierung",
        description:
          "Wir helfen dabei, Pilotprojekte auf großangelegte Implementierungen zu erweitern, uns an neue Anforderungen anzupassen und nachhaltiges Wachstum zu ermöglichen.",
      },
    },
  },
  footer: {
    partnerText:
      "Wir arbeiten mit Partnern und autorisierten Wiederverkäufern zusammen, die unsere Vision für die Weiterentwicklung der digitalen Gesundheit teilen.",
    becomePartner: "Partner werden",
    ourOffices: "Unsere Büros",
    thessalonikiHQ: "Thessaloniki HQ",
    thessalonikiAddress: "10th km Thessalonikis - N. Moudanion,",
    thessalonikiAddress2: "Balkan Center, Building D, 57001",
    athens: "Athen",
    athensAddress: "Priinis 4, Nea Smyrni, 17122",
    ioannina: "Ioannina",
    ioanninaAddress: "Science and Technology Park of Epirus, 45500",
    vidavoEU: "Vidavo EU – Lüttich, Belgien",
    vidavoEUAddress: "Quai sur - Meuse 19, 4000 Lüttich, Belgien",
    callUsAt: "Rufen Sie uns an",
    emailUsAt: "Schreiben Sie uns",
    followUs: "Folgen Sie uns",
    copyright: "© 2025 VIDAVO.",
    allRightsReserved: "Alle Rechte vorbehalten.",
    personalData: "Personenbezogene Daten",
    cookieNotice: "Cookie-Hinweis",
    backToTop: "Nach oben",
    aboutVidavo: "Erfahren Sie mehr über Vidavo",
  },
  services: {
    hero: {
      title: "Unsere Dienstleistungen",
      subtitle:
        "Umfassende digitale Gesundheitslösungen, die Telemedizin, Wellness, intelligente Gesundheitssysteme und strategische Beratungsdienstleistungen umfassen.",
    },
    categories: {
      telemedicine: {
        title: "Telemedizin & Pflege Lösungen",
        description: "Fernversorgung, die Patienten und Anbieter jederzeit und überall verbindet.",
        services: [
          {
            title: "Chronische Krankheiten Telemedizin",
            description: "Fernüberwachung und -management chronischer Erkrankungen",
          },
          {
            title: "Digitale Ambulanz",
            description: "Virtuelle Konsultationen und digitale Gesundheitsdienste",
          },
          {
            title: "Notfall & Panik-Taste",
            description: "Sofortige Notfallreaktion und Panikalarm-Systeme",
          },
          {
            title: "Schwangerschaftsüberwachung & Unterstützung",
            description: "Umfassende Schwangerschaftsbetreuung und Überwachungslösungen",
          },
          {
            title: "Psychische Gesundheitsunterstützung",
            description: "Umfassende Dienstleistungen für psychische Gesundheit und psychisches Wohlbefinden",
          },
          {
            title: "Maritime Telemedizin",
            description: "Gesundheitslösungen für maritime und abgelegene Standorte",
          },
        ],
      },
      wellness: {
        title: "Wellness & Präventive Gesundheit",
        description:
          "Werkzeuge und Programme, die einen gesünderen Lebensstil und frühzeitige Intervention unterstützen.",
        services: [
          {
            title: "Verhaltensänderungslösungen",
            description: "Evidenzbasierte Programme für nachhaltige Lifestyle-Änderungen",
          },
          {
            title: "Betriebliches Wohlbefinden",
            description: "Mitarbeiter-Wellness-Programme und betriebliche Gesundheitslösungen",
          },
          {
            title: "Wissenschaftliches Wellness",
            description: "Forschungsbasierte Wellness-Interventionen und Protokolle",
          },
          {
            title: "eHealth & Wellness-Tourismus",
            description: "Digitale Gesundheitslösungen für Wellness-Reisen und Tourismus",
          },
        ],
      },
      smartHealth: {
        title: "Next-Gen HealthTech",
        description: "Intelligente Technologien, die Daten in umsetzbare Gesundheitserkenntnisse verwandeln.",
        services: [
          {
            title: "InsurTech",
            description: "Versicherungstechnologie-Lösungen für Gesundheitsversorgung",
          },
          {
            title: "Digitale Therapeutika & Pharma",
            description: "Evidenzbasierte therapeutische Interventionen über digitale Plattformen",
          },
          {
            title: "Digitale Tiergesundheit",
            description: "Veterinär-Telemedizin und Tiergesundheitsüberwachung",
          },
          {
            title: "Öko-Gesundheits-Analytik",
            description: "Umweltgesundheitsüberwachung und Analyselösungen",
          },
          {
            title: "KI-Entscheidungsunterstützung",
            description: "Künstliche Intelligenz für klinische Entscheidungsfindung",
          },
          {
            title: "DRG-Entscheidungsunterstützung",
            description: "Diagnose-bezogene Gruppen-Klassifikation und Optimierungssysteme",
          },
        ],
      },
      advisory: {
        title: "Strategie & Beratung",
        description: "Expertenberatung zur Gestaltung, Umsetzung und Skalierung digitaler Gesundheitsinitiativen.",
        services: [
          {
            title: "Digitale Gesundheitsberatung",
            description: "Strategische Beratung für digitale Transformation im Gesundheitswesen",
          },
        ],
      },
    },
    servicesAvailable: "Verfügbare Dienstleistungen",
    cta: {
      title: "Bereit, das Gesundheitswesen zu Transformieren?",
      description:
        "Entdecken Sie, wie unsere umfassenden digitalen Gesundheitslösungen Ihre Gesundheitsversorgung revolutionieren und die Patientenergebnisse verbessern können.",
      scheduleConsultation: "Beratung Vereinbaren",
    },
  },
  chronicConditionManagement: {
    title: "Management chronischer Erkrankungen",
    subtitle:
      "Umfassende digitale Lösungen zur Behandlung chronischer Erkrankungen mit kontinuierlicher Überwachung und personalisierten Behandlungsplänen.",
    ourApproach: {
      title: "Unser Ansatz",
      description:
        "Wir bieten integrierte Gesundheitslösungen, die Patienten und Gesundheitsdienstleistern helfen, chronische Erkrankungen durch fortschrittliche Technologie und personalisierte Pflegeprotokolle effektiver zu behandeln.",
    },
    keyFeatures: {
      title: "Hauptmerkmale",
      features: [
        "Echtzeit-Gesundheitsüberwachung und Warnungen",
        "Personalisierte Behandlungspläne",
        "Medikamentenmanagement und Erinnerungen",
        "Regelmäßige Gesundheitsbewertungen",
        "Koordination der Gesundheitsdienstleister",
        "Patientenbildung und Unterstützungsressourcen",
      ],
    },
    conditionsWeSupport: {
      title: "Unterstützte Erkrankungen",
      description:
        "Unsere Plattform unterstützt die Behandlung verschiedener chronischer Erkrankungen, einschließlich Diabetes, Bluthochdruck, Herzerkrankungen, COPD und anderer langfristiger Gesundheitszustände, die fortlaufende Pflege und Überwachung erfordern.",
    },
  },
  serviceModal: {
    title: "Servicedetails",
    description:
      "Detaillierte Informationen zum ausgewählten Service einschließlich Medien, Beschreibung und Funktionen.",
    altTexts: {
      mobileHealthApp: "Mobile Gesundheitsüberwachungs-App mit Oxymetrie-Messungen und Aktivitätsverfolgung",
      insurtechDashboard: "InsurTech-Dashboard mit Versicherungsanalysen und -verwaltung",
      ecoHealthDashboard: "Eco-Health Analytics Dashboard mit Umwelt- und Gesundheitsdatenkorrelationen",
      digitalAnimalHealth: "Digitale Tiergesundheitsplattform mit Veterinär-Dashboard und Anfragenverwaltung",
      aiDecisionSupport:
        "KI-Entscheidungsunterstützungs-App mit kontaktloser Vitalzeichenerfassung und Gesundheitsanalyse",
      digitalHealthConsulting: "Digital Health Consulting-Strategieplan mit Zielen, Standards und Ergebnissen",
      scientificWellness:
        "Scientific Wellness Mobile App mit Schlaf- und Herzfrequenzüberwachung und Datenvisualisierung",
      ehealthWellnessTourism:
        "eHealth & Wellness Tourism Mobile App im Trainingsmodus mit Timer und Fortschrittsverfolgung",
    },
    specificDescriptions: {
      insurtech:
        "Die digitale Transformation gestaltet die Versicherungsbranche neu und verlagert den Fokus vom Schadenmanagement auf proaktive Gesundheit und langfristigen Kundenwert.",
      ecoHealth:
        "Umweltbedingungen prägen die menschliche Gesundheit. Eco-Health-Analysen decken diese Zusammenhänge auf, indem sie Umwelt- und klinische Informationen kombinieren, um Muster zu erkennen, Risiken vorherzusagen und intelligentere Entscheidungen für Städte und Industrie zu leiten.",
      aiDecisionSupport:
        "Künstliche Intelligenz tritt als klinischer Partner auf. Von einem schnellen Kamera-Scan der Vitalzeichen bis zu Vorhersagen, die die Versorgung leiten, verwandelt sie Rohdaten in umsetzbare Unterstützung für Ärzte und Patienten.",
      digitalHealthConsulting:
        "Gesundheitsorganisationen, Kommunen und Versicherer stehen unter Druck, sich mit digitalen Tools zu modernisieren, doch die Komplexität von Vorschriften, Interoperabilität und Change Management macht dies herausfordernd. Unsere Beratungsdienste helfen, diesen Übergang mit Klarheit und Strategie zu meistern.",
      scientificWellness:
        "Prävention tritt in die Ära der Präzision ein. Scientific Wellness integriert genetische Daten, Biomarker und digitale Gesundheitskennzahlen, um individualisierte, wissenschaftlich fundierte Wellness-Strategien zu entwickeln.",
      ehealthWellnessTourism:
        "Tourismus und Gesundheit kreuzen sich auf neue Weise. eHealth- und Wellness-Tourismus kombiniert präventive Check-ups und Wellness-Programme mit Reiseerlebnissen und bietet Besuchern langfristige digitale Nachsorge nach ihrem Aufenthalt.",
    },
  },
  serviceData: {
    chronicDiseaseTelemedicine: {
      description:
        "Digitale Werkzeuge für kontinuierliches Management chronischer Krankheiten, die es Patienten ermöglichen, gesünder zu leben, während Gesundheitsdienstleister überwachen, eingreifen und die Versorgung aus der Ferne anpassen können.",
      features: [
        {
          title: "Gesundheitsakte",
          description:
            "Personalisierte medizinische Akte mit Profil, Verlauf, Biosignalaufzeichnungen, Medikamenten und mehr.",
        },
        { title: "Telemetrie", description: "Drahtlose Überwachung von Vitalzeichen mit Echtzeit-Cloud-Übertragung" },
        {
          title: "Warnungen und Benachrichtigungen",
          description: "Personalisierte Warnungen, Erinnerungen und Benachrichtigungen für Patienten und Kliniker",
        },
        {
          title: "Maßgeschneiderte digitale Umgebungen",
          description: "Dedizierte mobile App, Webplattform und Dashboards für Patienten und Gesundheitsfachkräfte",
        },
        {
          title: "Pflegeplan-Management",
          description: "Strukturierte Pflegepläne mit Medikamenteneinhaltung, Aktivitätszielen und Nachsorgeplanung",
        },
        {
          title: "Fernkonsultationen",
          description: "Audio-/Videokommunikation, Chat, sicherer Dateiaustausch und Online-Konsultation",
        },
      ],
    },
    digitalOutpatientClinic: {
      description:
        "Die Digitale Ambulanz verwandelt Routinebesuche und Nachuntersuchungen in sichere, bequeme Online-Interaktionen. Patienten verbinden sich von überall mit ihren Ärzten, während Kliniker Termine, Aufzeichnungen und Pflegepläne auf einer einzigen Plattform verwalten.",
      features: [
        {
          title: "Fernkonsultationen",
          description: "Chat, Video und sichere Nachrichtenübermittlung für direkte Patient-Arzt-Kommunikation.",
        },
        {
          title: "Planung und Verwaltung",
          description: "Integrierter Kalender für Buchungen, Erinnerungen und Nachfolgetermine.",
        },
        {
          title: "Integrierte Gesundheitsdaten",
          description: "Bringt Gesundheitsakten, Fragebögen und medizinische Dateien an einem Ort zusammen.",
        },
        {
          title: "Anpassbare Umgebungen",
          description:
            "Flexible Arbeitsabläufe für verschiedene Fachgebiete (Kardiologie, Endokrinologie, Dermatologie).",
        },
        { title: "E-Rezepte und Medikamentenverwaltung", description: "Ermöglicht Ärzten digitale Rezeptausstellung." },
        { title: "Abrechnungsunterstützung", description: "Optionales Modul zur Verwaltung von Patientenzahlungen." },
      ],
    },
    emergencyPanicButton: {
      description:
        "Sofortiger Zugang zu Hilfe in dringenden Situationen. Mit einem einzigen Tastendruck können Patienten Pflegekräfte, Kliniker oder Rettungsdienste alarmieren und so eine schnelle Reaktion sicherstellen, wenn es am wichtigsten ist.",
      features: [
        { title: "Ein-Klick-Alarm", description: "Sofortiger Hilferuf über dedizierten Panikknopf." },
        {
          title: "Echtzeit-Ortung",
          description: "GPS-Tracking zur Führung von Pflegekräften oder Rettungskräften zur Position des Nutzers.",
        },
        {
          title: "Geo-Zonen und Benachrichtigungen",
          description:
            "Konfigurierbare Sicherheitszonen; Alarme werden gesendet, wenn der Träger vordefinierte Grenzen verlässt.",
        },
        {
          title: "Sturzerkennung",
          description:
            "Automatische Sturzerkennung und Alarmübertragung, auch wenn der Benutzer den Knopf nicht drücken kann.",
        },
        {
          title: "Integrierte Kommunikation",
          description: "Direkte Sprach- oder Videoverbindung mit Klinikern, Callcentern oder Familienmitgliedern.",
        },
        {
          title: "Anpassbare Eskalationspfade",
          description:
            "Konfigurierbare Arbeitsläufe, die festlegen, wer zuerst benachrichtigt wird (Familie, Pflegekraft, Notfallteam).",
        },
      ],
    },
    mentalHealthSupport: {
      description:
        "Zugängliche digitale Dienste, die die klinische Versorgung ergänzen und kontinuierliche Bewertung, strukturierte Interventionen und verbesserte Patienteneinbindung ermöglichen.",
      features: [
        {
          title: "Klinische Bewertungstools",
          description: "Standardisierte Fragebögen für Depression, Angst und Stimmungstracking.",
        },
        {
          title: "Fernberatung",
          description: "Sichere Chat- oder Videositzungen mit Psychologen, Psychiatern oder zertifizierten Coaches.",
        },
        {
          title: "Bildungsressourcen",
          description:
            "Wissenschaftlich validierte Ressourcen und psychoedukative Inhalte zur Unterstützung von Adhärenz und Selbstmanagement.",
        },
        {
          title: "Risikomanagement",
          description:
            "Konfigurierbare Alarme für Krisensituationen, die eine rechtzeitige Eskalation an Kliniker oder Pflegekräfte gewährleisten.",
        },
        {
          title: "Behandlungsplanung",
          description:
            "Werkzeuge für Kliniker zur Festlegung von Therapiezielen, Zuweisung digitaler Übungen und Überwachung der Adhärenz.",
        },
        {
          title: "Fortschrittsverfolgung",
          description:
            "Längsschnittüberwachung des Symptomverlaufs und der Behandlungsreaktion durch strukturierte Dashboards.",
        },
      ],
    },
    pregnancyMonitoring: {
      description:
        "Digitale Gesundheitslösungen, die Mütter durch jede Phase der Schwangerschaft begleiten, kombinieren Überwachung, Aufklärung und Expertenzugang für sicherere und selbstbewusstere Reisen.",
      features: [
        {
          title: "Vernetzte Geräte & Wearables",
          description:
            "Verfolgung von Vitalzeichen (Blutdruck, Herzfrequenz, Glukose, Gewicht) und fetalem Wohlbefinden mit medizinischen Geräten.",
        },
        {
          title: "Bildungsressourcen",
          description: "Zugang zu evidenzbasierten Inhalten, Tipps und Richtlinien für jede Phase der Schwangerschaft.",
        },
        {
          title: "Expertenverbindung",
          description:
            "Direkte Kommunikation mit Gynäkologen, Hebammen oder anderen Spezialisten für Beruhigung und zeitnahe Anleitung.",
        },
        {
          title: "Pflegeplan & Erinnerungen",
          description:
            "Personalisierte Zeitpläne für Untersuchungen, Tests, Ernährung, Bewegung und Medikamenteneinhaltung.",
        },
        {
          title: "Digitales Tagebuch",
          description:
            "Mütter können tägliche Symptome, Stimmungen und Lebensgewohnheiten protokollieren für vollständigere Pflegeeinblicke.",
        },
      ],
    },
    marineTelemedicine: {
      description:
        "Gesundheitsversorgung auf See ist aufgrund von Entfernung, begrenzten Ressourcen und intermittierender Konnektivität herausfordernd. Marine Telemedizin überbrückt diese Lücke, indem sie Schiffe mit Werkzeugen für die Erstversorgung ausstattet",
      features: [
        {
          title: "Von der Besatzung initiierte Versorgung",
          description: "Benannte Offiziere fungieren als Ersthelfer, unterstützt von entfernten Spezialisten.",
        },
        {
          title: "Offline-First-Design",
          description:
            "Medizinische Daten werden während des Vorfalls aufgezeichnet und mit Experten synchronisiert, sobald Internetzugang wiederhergestellt ist.",
        },
        {
          title: "Vernetzte medizinische Geräte",
          description:
            "Borddiagnostikwerkzeuge (EKG, Oximeter, Blutdruckmessgeräte) erfassen Vitalzeichen zur Fernüberprüfung.",
        },
        {
          title: "Bild- und Dateiaustausch",
          description:
            "Fotos, Scans oder andere Dokumente können mit Spezialisten geteilt werden, um eine genaue Bewertung zu unterstützen.",
        },
        {
          title: "Fernkonsultationen",
          description:
            "Video oder Nachrichtenübermittlung mit Ärzten an Land für Triage, Akutversorgung oder chronisches Krankheitsmanagement.",
        },
        {
          title: "Logistikintegration",
          description:
            "Koordination mit Häfen, Kliniken und Evakuierungsdiensten, wenn Vor-Ort-Versorgung erforderlich ist.",
        },
      ],
    },
    behaviouralChangeSolutions: {
      description:
        "Gewohnheiten zu ändern steht im Mittelpunkt der Prävention. Verhaltensänderungslösungen kombinieren digitale Werkzeuge mit evidenzbasierten Methoden, um einen gesünderen Lebensstil zu fördern und langfristige Einhaltung zu unterstützen.",
      features: [
        {
          title: "Personalisierte Programme",
          description:
            "Maßgeschneiderte Pläne für Ernährung, Aktivität und Lifestyle-Änderungen basierend auf individuellen Bedürfnissen.",
        },
        {
          title: "Zielsetzung und Erinnerungen",
          description:
            "Strukturierte Ziele mit intelligenten Benachrichtigungen, die Benutzer engagiert und auf Kurs halten.",
        },
        {
          title: "Tägliche Überwachung",
          description:
            "Tägliche Verfolgung von Schritten, Aktivität, Gewicht und anderen wichtigen Wellness-Indikatoren.",
        },
        {
          title: "Motivierendes Feedback",
          description: "Ermutigung und Echtzeit-Einblicke, die langfristigen Fortschritt aufrechterhalten.",
        },
        {
          title: "Bildungsinhalte",
          description: "Evidenzbasierte Ressourcen, die die Wissenschaft hinter gesunden Entscheidungen erklären.",
        },
        {
          title: "Fortschrittsvisualisierung",
          description: "Klare Diagramme und Dashboards, die Meilensteine und Gesamtverbesserung hervorheben.",
        },
      ],
    },
    corporateWellbeing: {
      description:
        "Gesunde Arbeitsplätze schaffen stärkere Unternehmen. Betriebliche Wellnessprogramme verbessern die Gesundheit der Mitarbeiter, reduzieren Fehlzeiten und schaffen eine Kultur des Engagements und der Resilienz.",
      features: [
        {
          title: "Markenplattformen",
          description: "Arbeitgebermarkenplattformen, die Wohlbefinden in der gesamten Belegschaft fördern.",
        },
        {
          title: "Gesundheitsprogramme",
          description:
            "Programme zur Unterstützung von Stressmanagement, körperlicher Aktivität und psychischer Gesundheit.",
        },
        {
          title: "Engagement-Tools",
          description: "Digitale Tools, die Teilnahme durch Erinnerungen und Gamification fördern.",
        },
        {
          title: "Lifestyle-Ressourcen",
          description: "Zugang zu Ressourcen für gesündere Ernährung und Lifestyle-Entscheidungen.",
        },
        {
          title: "Belegschaftsanalytik",
          description: "Analysen, die HR helfen, Teilnahme, Ergebnisse und Return on Investment zu verfolgen.",
        },
        {
          title: "Richtlinienintegration",
          description: "Ausrichtung an bereits bestehenden Arbeitsschutz- und Gesundheitsrichtlinien.",
        },
      ],
    },
    scientificWellness: {
      description:
        "Prävention tritt in die Ära der Präzision ein. Scientific Wellness integriert genetische Daten, Biomarker und digitale Gesundheitskennzahlen, um individualisierte, wissenschaftlich fundierte Wellness-Strategien zu entwickeln.",
      features: [
        {
          title: "Umfassende Profilierung",
          description:
            "Erfassung genetischer, biomarker- und lebensstilbezogener Daten zum Aufbau des individuellen Gesundheitsprofils.",
        },
        {
          title: "Personalisierte Planung",
          description: "Wellnessstrategien auf wissenschaftlicher Grundlage mit messbaren Zielen.",
        },
        {
          title: "Kontinuierliche Überwachung",
          description:
            "Echtzeit-Tracking biologischer Signale wie Stress, Herzfrequenzvariabilität und Stoffwechselmarker.",
        },
        {
          title: "Adaptive Empfehlungen",
          description: "Feedback-Schleifen, die Empfehlungen anpassen, sobald neue Daten erfasst werden.",
        },
        {
          title: "Wissenschaftliche Ressourcen",
          description: "Bildungsmaterial, das die Wissenschaft hinter jeder Empfehlung erklärt.",
        },
        {
          title: "Einblicke",
          description: "Visuelle Dashboards, die Fortschritte zeigen und aufkommende Gesundheitstrends hervorheben.",
        },
      ],
    },
    ehealthWellnessTourism: {
      description:
        "Tourismus und Gesundheit kreuzen sich auf neue Weise. eHealth- und Wellness-Tourismus kombiniert präventive Check-ups und Wellness-Programme mit Reiseerlebnissen und bietet Besuchern langfristige digitale Nachsorge nach ihrem Aufenthalt.",
      features: [
        {
          title: "Präventive Bewertungen",
          description: "Vor-Ort-Gesundheitsbewertungen, die in Wellness-Reisepakete integriert sind.",
        },
        {
          title: "Personalisierte Ernährung",
          description:
            "Hotels und Resorts, die Essensoptionen an das Gesundheitsprofil und die Wellnessziele des Gastes anpassen.",
        },
        {
          title: "Wellnesspläne",
          description: "Personalisierte Wellnesspläne, die medizinische Beratung mit Lifestyle-Coaching kombinieren.",
        },
        {
          title: "Kulturelle Integration",
          description:
            "Programme, die lokale Kultur, Natur und Wellnesspraktiken für ganzheitliche Erlebnisse vereinen.",
        },
        {
          title: "Kontinuität der Pflege",
          description:
            "Datenintegration, die die Kontinuität der Pflege zwischen touristischen Dienstleistungen und Gesundheitsanbietern gewährleistet.",
        },
        {
          title: "Wellness-Dashboards",
          description:
            "Digitale Aufzeichnungen und Dashboards, die Besuchern helfen, ihre Wellness-Reise im Laufe der Zeit zu verfolgen.",
        },
      ],
    },
    insurtech: {
      description:
        "Die digitale Transformation gestaltet die Versicherungsbranche neu und verlagert den Fokus vom Schadenmanagement auf proaktive Gesundheit und langfristigen Kundenwert.",
      features: [
        {
          title: "Telekonsultationen",
          description:
            "Online-Medizinsitzungen in Versicherungspaketen enthalten, verbessern den Zugang und senken die Kosten.",
        },
        {
          title: "Tele-Underwriting",
          description:
            "Ferngesundheitsbewertung für schnellere, genauere Risikostratifizierung und Genehmigung von Versicherungspolicen.",
        },
        {
          title: "Personalisierte Versorgung",
          description:
            "Fokus auf Prävention, Früherkennung und Fernüberwachung zur Reduzierung von Schadensfällen und Verbesserung der Ergebnisse.",
        },
        {
          title: "Kundenerlebnis",
          description:
            "Marken- oder White-Label-Mobile-Apps, die Zugänglichkeit, Loyalität und Benutzerzufriedenheit verbessern.",
        },
        {
          title: "Datengesteuertes Risikomanagement",
          description:
            "Erweiterte Analysen, die Underwriting-Genauigkeit verbessern, Kosten prognostizieren und intelligenteres Produktdesign unterstützen.",
        },
        {
          title: "Neue Geschäftsmodelle",
          description:
            "Ermöglichen Versicherern, präventive, wertbasierte Produkte zu entwerfen, die Dienstleistungsangebot und Wettbewerbsfähigkeit erweitern.",
        },
      ],
    },
    digitalTherapeuticsPharma: {
      description:
        "Wenn Medizin die Schachtel verlässt, wird sie digital. Wir bieten Software-Interventionen und Begleit-Apps, die Behandlung erweitern, Adherence verbessern und Real-World-Evidence generieren.",
      features: [
        {
          title: "Begleit-Apps für Medikamente",
          description:
            "Marken- oder White-Label-Anwendungen, die Patienten bei der Medikamenteneinnahme anleiten, Erinnerungen bieten und maßgeschneiderte Bildungsinhalte liefern.",
        },
        {
          title: "Evidenzbasierte digitale Therapeutika",
          description:
            "Klinisch validierte Apps und Interventionen für spezifische Erkrankungen wie Diabetes, Schlaflosigkeit oder Depression.",
        },
        {
          title: "Unterstützung bei Medikamenteneinhaltung",
          description:
            "Pillen-Erinnerungen, digitale Tagebücher und verbundene Geräte, die Behandlungstreue verstärken.",
        },
        {
          title: "Unterstützung klinischer Studien (eCRF-Module)",
          description:
            "Elektronische Fallberichtsformulare mit integrierten Fragebögen, Symptomverfolgung und digitaler Überwachung, entwickelt zur Vereinfachung der Studiendatensammlung.",
        },
        {
          title: "Analytik und Berichterstattung",
          description:
            "Automatisierte Analyse von patientenberichteten Ergebnissen und klinischen Daten, die regulierungsreife Berichte generieren.",
        },
        {
          title: "Patientenengagement",
          description:
            "Interaktive Funktionen, die Patienten durch Feedback, Fortschrittsverfolgung und Kommunikation mit Studienkoordinatoren oder Pflegeteams motivieren.",
        },
      ],
    },
    digitalAnimalHealth: {
      description:
        "Von Haustieren zu Hause bis zu Herden auf dem Feld transformieren digitale Werkzeuge die Veterinärversorgung. Unsere Lösungen bringen Überwachung, Aufzeichnungen und Expertenberatung in eine verbundene Umgebung.",
      features: [
        {
          title: "Tele-Veterinär-Konsultationen",
          description:
            "Buchen und verwalten Sie Veterinärtermine online für Check-ups, Nachsorge und Notfallsituationen.",
        },
        {
          title: "Digitale Gesundheitsakten",
          description: "Umfassende Tierprofile einschließlich Impfplänen, Behandlungen, Ernährung und Diagnostik.",
        },
        {
          title: "Fernbetreuungsanleitung",
          description:
            "Digitale Anweisungen und Nachsorgepläne für Ernährung, Erholung und Präventionsroutinen nach Veterinärbesuchen.",
        },
        {
          title: "Überwachung auf Populationsebene",
          description:
            "Analysen für Viehherden, Tierheime und Zuchtprogramme zur Unterstützung von Krankheitsprävention und Wohlfahrtsmanagement.",
        },
        {
          title: "Integration mit Veterinärpharma",
          description:
            "Begleit-Apps, die mit Behandlungen verknüpft sind, um Adherence zu unterstützen und Ergebnisse zu verfolgen.",
        },
        {
          title: "Datenanalytik und Berichterstattung",
          description: "Frühwarnsysteme für Krankheitsausbrüche, Leistungsverfolgung und optimierte Pflegestrategien.",
        },
      ],
    },
    ecoHealthAnalytics: {
      description:
        "Umweltbedingungen prägen die menschliche Gesundheit. Öko-Gesundheits-Analysen decken diese Zusammenhänge auf, indem sie Umwelt- und klinische Informationen kombinieren, um Muster zu erkennen, Risiken vorherzusagen und intelligentere Entscheidungen für Städte und Industrie zu leiten.",
      features: [
        {
          title: "Öffentliche Datensätze",
          description: "Import und Verarbeitung von Datensätzen aus etablierten Umweltindikatoren-Datenbanken.",
        },
        {
          title: "Umweltdaten-Feeds",
          description:
            "Datenströme von Umweltsensoren, die Luftqualität, Schadstoffe oder Klimaindikatoren aus Sensornetzwerken und offenen APIs messen, um Gesundheitsanalysen anzureichern.",
        },
        {
          title: "Gesundheits-Umwelt-Korrelation",
          description:
            "Analyse kombinierter Datensätze zur Identifizierung von Mustern, Trends und Risikofaktoren, die Umweltbelastungen mit Gesundheitsergebnissen verknüpfen",
        },
        {
          title: "Trendanalyse und Warnungen",
          description:
            "Überwachung langfristiger Expositionsniveaus und automatische Warnungen für Hochrisikoereignisse wie Hitzewellen oder Verschmutzungsspitzen.",
        },
        {
          title: "Entscheidungsunterstützung für Städte und Industrie",
          description:
            "Bereitstellung evidenzbasierter Erkenntnisse zur Unterstützung der Stadtplanung, Arbeitsmedizin und unternehmerischer Nachhaltigkeitsstrategien.",
        },
        {
          title: "Visualisierung und Dashboards",
          description:
            "Interaktive Karten und Dashboards, die Umweltindikatoren neben Gesundheitsergebnissen anzeigen für einfachere Interpretation.",
        },
      ],
    },
    aiDecisionSupport: {
      description:
        "Intelligente klinische Assistenz durch fortgeschrittene KI zur Verbesserung der Entscheidungsfindung, Optimierung von Arbeitsabläufen und Verbesserung der Patientenergebnisse.",
      features: [
        {
          title: "KI-Aktendurchsicht",
          description:
            "Ruft relevante Elemente aus dem Patientenprofil ab und fasst sie zusammen, damit Ärzte Untersuchungen, Anamnese, Medikamente und Notizen schnell durchsehen können.",
        },
        {
          title: "Kontaktlose Vitalzeichen",
          description:
            "Messen Sie Herzfrequenz und Wellness-Indikatoren über die Telefonkamera mit fortschrittlicher rPPG-Technologie. In nur einem kurzen Scan erhalten Patienten Erkenntnisse so einfach wie ein Selfie.",
        },
        {
          title: "Risikobewertung und -vorhersage",
          description:
            "Fragebogenbasierte Bewertung und KI-Modelle, gepaart mit maßgeschneiderten Lifestyle-Ratschlägen.",
        },
        {
          title: "Symptom-Checker",
          description:
            "Vom Patienten eingegebene Symptome werden von KI bewertet mit vorgeschlagenen Maßnahmen und Anleitung, wann Hilfe zu suchen ist.",
        },
        {
          title: "Klinische Entscheidungsunterstützung",
          description:
            "Modelle, die Verschlechterungsrisiko kennzeichnen, nächste Schritte vorschlagen und präventive und personalisierte Interventionen unterstützen.",
        },
        {
          title: "Business Intelligence",
          description:
            "Dashboards, die Aktivitäten in Einrichtungen analysieren, um Personalplanung, Entlassungsplanung und Nachsorge zu optimieren, während Wiederaufnahmen und Kosten verfolgt werden.",
        },
      ],
    },
    drgDecisionSupport: {
      description:
        "Diagnose-bezogene Gruppen (DRGs) sind mehr als ein Erstattungsinstrument. Effektiv eingesetzt werden sie zu einem Entscheidungsunterstützungsmechanismus, der Kostenkontrolle, Transparenz und Vertrauen zwischen Versicherern, Anbietern und Patienten verbessert und gleichzeitig Krankenhäuser bei präzisem Kodieren und Prüfen unterstützt.",
      features: [
        {
          title: "Kostenoptimierung",
          description:
            "Standardisierte Kostenberechnung medizinischer Fälle nach Diagnose und klinischer Schwere reduziert Variabilität und macht Gesundheitsausgaben vorhersehbarer.",
        },
        {
          title: "Transparente Preisgestaltung",
          description:
            "Unterstützt Versicherer, Anbieter und Patienten mit zuverlässigen, vergleichbaren Kostenmodellen, die Vertrauen und Wettbewerbsfähigkeit stärken.",
        },
        {
          title: "Risikobewertung für Versicherungen",
          description:
            "Verbessert die Risikoeinschätzung für Gruppen- und Einzelkrankenversicherungen und hilft bei der Gestaltung nachhaltiger Versicherungsprodukte.",
        },
        {
          title: "Unterstützung bei Krankenhaus-Kodierung",
          description:
            "Unterstützt Kliniker und Kodierer bei korrekter und konsistenter Fallerfassung basierend auf ICD- und GPC-Klassifikationen.",
        },
        {
          title: "Audit und Qualitätskontrolle",
          description:
            "Automatisierte Audit-Mechanismen identifizieren Schwächen in der Kodierung medizinischer Aufzeichnungen und unterstützen frühzeitige Korrekturmaßnahmen.",
        },
        {
          title: "Gezielte Verbesserungen",
          description:
            "Audit-Ergebnisse leiten Interventionen wie Personalschulungen, Updates operativer Richtlinien und Kodierungsverfeinerungen.",
        },
      ],
    },
    digitalHealthConsulting: {
      description:
        "Strategische Beratung und Expertenbegleitung für Gesundheitsorganisationen bei der digitalen Transformation und Innovation.",
      features: [
        {
          title: "Digital-Health-Strategie",
          description:
            "Entwicklung von Roadmaps für Krankenhäuser, Kommunen und Versicherer zur Einführung und Skalierung digitaler Lösungen.",
        },
        {
          title: "Interoperabilität und Integration",
          description:
            "Beratung zu Standards wie HL7 FHIR, DICOM und openEHR, um sichere und effektive Systemkommunikation zu gewährleisten.",
        },
        {
          title: "Prozess-Redesign",
          description:
            "Unterstützung bei der Umstrukturierung klinischer und administrativer Arbeitsabläufe zur Ausrichtung auf digitale Transformationsziele.",
        },
        {
          title: "Regulatory Compliance",
          description:
            "Expertise zu MDR, DSGVO und nationalen Rahmenbedingungen, um sicherzustellen, dass Projekte rechtliche und ethische Anforderungen erfüllen.",
        },
        {
          title: "Kapazitätsaufbau",
          description: "Schulungs- und Unterstützungsprogramme für Kliniker, Administratoren und technische Teams.",
        },
        {
          title: "Evaluation und KPIs",
          description:
            "Gestaltung von Monitoring-Frameworks mit messbaren Indikatoren für Leistung, Effizienz und Wirkung.",
        },
      ],
    },
  },
  investorRelations: {
    title: "Investor Relations",
    description:
      "VIDAVO wurde 2002 gegründet, hat seinen Hauptsitz in Thessaloniki, Griechenland, und Büros in Athen. Es ist am Alternativen Markt (ΕΝ.Α. Growth) der Euronext Athens notiert (OASIS: BINTA).",
    stockExchange: {
      title: "Börsenveröffentlichungen",
      ticker: "OASIS-Ticker",
      description:
        "Eine detaillierte Übersicht über vergangene und aktuelle Marktinformationen der Aktie, die durch das Tickersymbol identifiziert wird",
      issuersCorner: "Emittenten-Bereich",
      stockInfo: "Aktieninfo",
    },
    keyMetrics: {
      revenueGrowth: {
        label: "Umsatzwachstum",
        value: "45%",
        description: "Jährliches Wachstum",
      },
      marketPenetration: {
        label: "Marktdurchdringung",
        value: "15+",
        description: "Bediente Länder",
      },
      healthcarePartners: {
        label: "Gesundheitspartner",
        value: "250+",
        description: "Aktive Partnerschaften",
      },
      patientLives: {
        label: "Betroffene Patientenleben",
        value: "1M+",
        description: "Über unsere Plattformen",
      },
    },
    documents: {
      title: "Investorendokumente",
      download: "Herunterladen",
      categories: {
        financial: "Jahresberichte",
        governance: "Berichte 1. Halbjahr",
        presentations: "Bilanz",
        regulatory: "Ankündigungen",
        assemblies: "Hauptversammlungen",
      },
      names: {
        annualReport: "Jahresbericht",
        firstSemester: "1. Halbjahr",
        balanceSheet: "Bilanz",
        balanceSheetFirstSemester: "Bilanz (1. Halbjahr)",
        announcement: "Ankündigung",
        generalMeeting: "HV",
        corporatePresentation: "Jährliche Unternehmenspräsentation",
      },
    },
    contact: {
      title: "Investor Relations Kontakt",
      description:
        "Für Investitionsmöglichkeiten, Finanzinformationen oder Investorenanfragen wenden Sie sich bitte an unser Team",
      sendEmail: "E-Mail senden",
    },
  },

  careers: {
    title: "Karriere bei VIDAVO",
    subtitle:
      "Schließen Sie sich unserer Mission an, das Gesundheitswesen durch innovative Technologie zu transformieren. Bauen Sie Ihre Karriere auf und haben Sie gleichzeitig einen bedeutenden Einfluss auf globale Gesundheitsergebnisse.",
    whyWorkAtVidavo: {
      title: "Warum bei VIDAVO arbeiten",
      description:
        "Bei VIDAVO werden Sie Teil eines dynamischen Teams, das die Gesundheitsversorgung revolutioniert. Wir bieten ein kollaboratives Umfeld, in dem Innovation gedeiht und jedes Teammitglied dazu beiträgt, Leben durch Technologie zu verbessern.",
      culture: {
        title: "Unsere Kultur",
        description:
          "Wir fördern eine Kultur der Innovation, Zusammenarbeit und des kontinuierlichen Lernens. Unser Team ist leidenschaftlich für Gesundheitstechnologie und engagiert sich dafür, weltweit einen positiven Einfluss auf Patientenergebnisse zu haben.",
        values: {
          innovation: "Innovationsgetriebenes Umfeld",
          learning: "Kontinuierliche Lernmöglichkeiten",
          collaboration: "Kollaborative Teamkultur",
          impact: "Bedeutender Gesundheitseinfluss",
        },
      },
    },
    noOpenPositions: {
      description:
        "Wir freuen uns immer, Menschen kennenzulernen, die unsere Philosophie teilen und sich vorstellen können, mit uns zu wachsen. Für aktuelle Stellenangebote besuchen Sie bitte unsere",
      linkedIn: "LinkedIn",
      descriptionEnd:
        "-Seite. Wenn Sie glauben, dass Ihre Denkweise und Fähigkeiten mit unserer Arbeit übereinstimmen, würden wir uns freuen, von Ihnen zu hören.",
      sendEmail: "E-Mail senden",
    },
  },
  personalData: {
    badge: "DSGVO-DATENSCHUTZ",
    title: "Datenschutzerklärung und Datenschutz",
    description:
      "Wir danken Ihnen für den Besuch der Website von VIDAVO und versichern Ihnen, dass der Schutz Ihrer persönlichen Daten für uns oberste Priorität hat.",
    sections: {
      usefulDefinitions: "Nützliche Definitionen",
      dataController: "Datenverantwortlicher",
      whatDataWeProcess: "Welche Daten wir verarbeiten",
      informationRegardingCookies: "Informationen zu Cookies",
      yourRights: "Ihre Rechte und wie Sie diese ausüben können",
      periodOfStorage: "Speicherdauer der Daten",
      informationSecurityPolicy: "Informationssicherheitsrichtlinie",
      purposesAndLegalBasis: "Zwecke und Rechtsgrundlage für die Verarbeitung Ihrer Daten",
      thirdPartyLinks: "Links zu Websites Dritter",
      revisions: "Überarbeitungen",
      antiBriberyPolicy: "Anti-Korruptionsrichtlinie",
    },
    usefulDefinitionsContent: {
      intro: "Zu Ihrer besseren Information verwenden wir die folgenden Begriffe, die wie folgt definiert sind:",
      personalData:
        'a) "Personenbezogene Daten": sind Informationen, die sich auf eine natürliche Person beziehen. Daten gelten als personenbezogen, wenn die Person, die sie betreffen, direkt oder indirekt identifiziert werden kann (d.h. entweder durch Nennung des Namens, der Ausweisnummer, der Wohnadresse und anderer Kontaktdaten (Telefonnummer, E-Mails), der IP-Adresse des Geräts, das für den Online-Zugang verwendet wird, Alter, Geschlecht, äußere Merkmale, Familiensituation, Bildungsstand, Beruf, Interessen usw.). Die natürliche Person, auf die sich die personenbezogenen Daten beziehen, wird als "betroffene Person" bezeichnet.',
      sensitiveData:
        'b) "Besondere Kategorien personenbezogener Daten" (oder "sensible Daten"): sind Daten, die sich auf die Intimsphäre der Person beziehen (z.B. Gesundheit, religiöse Überzeugungen, politische Ansichten, gewerkschaftsbezogene Aktivitäten, ethnische Herkunft, Sexualleben).',
      dataProcessing:
        'c) "Datenverarbeitung": ist jede Aktivität, die personenbezogene Daten betrifft, unabhängig von den angewandten Mitteln (d.h. automatisiert oder manuell), wie die Erhebung, Speicherung, Organisation, Strukturierung, Aufbewahrung, Anpassung oder Änderung, Abfrage, Suche nach Informationen, Nutzung, Offenlegung durch Übermittlung, Verbreitung oder jede andere Form der Bereitstellung, Zuordnung oder Kombination, Einschränkung, Löschung oder Vernichtung.',
      legislation:
        'd) "Rechtsvorschriften": die griechische und europäische Gesetzgebung zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten, einschließlich der Datenschutz-Grundverordnung 2016/79 (DSGVO).',
      dataLogs:
        'e) "Datenprotokolle": elektronische Dateien über Bewegungen auf der Website, die auf unserem Server aufgezeichnet werden.',
      cookies:
        'f) "Cookies": Kleine Datendateien in Textform, die auf Ihrem elektronischen Gerät (Computer, Handy, Tablet) gespeichert werden, wenn Sie die Website besuchen und die',
      specificInformation: "spezifische Informationen",
      cookiesEnd: "über Ihre Bewegungen auf der Website bereitstellen.",
    },
    dataControllerContent: {
      paragraph1:
        "Datenverantwortlicher: Der Datenverantwortliche gemäß Art. 4 Abs. 7 der Datenschutz-Grundverordnung (DSGVO) ist VIDAVO AE, BALKAN CENTER, 10 km Thessaloniki-N. Moudania, 57001 Thermi, vidavo@vidavo.eu.",
      paragraph2:
        'Sie können den Datenverantwortlichen unter der folgenden Adresse dpo@vidavo.eu oder unter der Postanschrift mit dem Vermerk "zu Händen des Datenverantwortlichen" kontaktieren.',
    },
    whatDataWeProcessContent: {
      sectionA: "A) Daten, die automatisch auf unserem Server protokolliert werden",
      dataLogs: "(1) Datenprotokolle",
      dataLogsIntro:
        "Wenn Sie unsere Website betreten, erfassen wir diejenigen personenbezogenen Daten (Datenprotokolle), die von Ihrem Browser an unseren Server übermittelt werden, und zwar insbesondere:",
      dataLogsList: [
        "IP-Adresse",
        "Datum und Uhrzeit Ihres Eintrags",
        "Zeitunterschied zur Greenwich Mean Time - GMT",
        "Inhalt der Anfrage (spezifische Seite)",
        "HTTP-Statuscode",
        "Jede Menge übertragener Daten",
        "Webseite, von der die Anfrage kommt",
        "Browser",
        "Betriebssystem",
        "Sprache und Version der Browser-Software",
      ],
      cookiesSubtitle: "(2) Cookies",
      cookiesText:
        'Zusätzlich zu den oben genannten Daten werden bei der Nutzung der Website Cookies auf Ihrem PC gespeichert, d.h. kleine Datendateien (Textdateien), die auf dem von Ihnen verwendeten Gerät gespeichert werden und Identifikationsdaten in Bezug auf Ihr Gerät an unseren Server übermitteln, d.h. es wird eine eindeutige Identifikationsnummer erstellt. Es ist zu beachten, dass mit Ausnahme von "Session-Cookies", die für Ihren ungehinderten Zugang und die Nutzung unserer Website absolut notwendig sind, alle anderen Cookies nur dann auf unserem Server gespeichert werden, wenn Sie Ihre Zustimmung erteilt haben und Sie diese aktivieren, wenn Sie unsere Website betreten.',
      sectionB: "B) Daten, die Sie eingeben",
      sectionBText:
        'Wenn Sie per E-Mail mit uns kommunizieren, speichern wir die von Ihnen bereitgestellten Daten (Ihre E-Mail, möglicherweise Ihren Namen und Ihre Telefonnummer), um auf Ihre Anfragen zu antworten. In diesem Zusammenhang löschen wir die betreffenden Daten oder reduzieren deren Verarbeitung, wenn die Speicherung nicht mehr erforderlich ist, sofern keine gesetzliche Verpflichtung zur Aufbewahrung der Daten besteht. Sie können uns jederzeit auffordern, Ihre E-Mail-Adresse nicht mehr zu verwenden und von weiteren Informationen/Mitteilungen abzusehen, indem Sie das "Widerspruchsrecht" gemäß den einschlägigen Rechtsvorschriften ausüben.',
    },
    cookiesInfoContent: {
      intro:
        "Unsere Website verwendet Cookies, um Ihr Surferlebnis zu verbessern, wesentliche Funktionen bereitzustellen und die Website-Nutzung zu analysieren. Nachfolgend finden Sie detaillierte Informationen zu den von uns verwendeten Cookies:",
      essentialTitle: "Notwendige Cookies",
      essentialText:
        "Diese Cookies sind erforderlich, damit die Website ordnungsgemäß funktioniert, und können nicht deaktiviert werden. Sie werden normalerweise als Reaktion auf von Ihnen durchgeführte Aktionen gesetzt, wie z.B. das Festlegen Ihrer Datenschutzpräferenzen, das Anmelden oder das Ausfüllen von Formularen.",
      analyticsTitle: "Analytische Cookies",
      analyticsText:
        "Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie Informationen anonym sammeln und melden. Dies hilft uns, die Leistung und Benutzererfahrung unserer Website zu verbessern.",
      tableHeaders: {
        cookieName: "Cookie-Name",
        category: "Kategorie",
        purpose: "Zweck",
        duration: "Dauer",
      },
      tableData: [
        {
          name: "cookie-consent",
          category: "Notwendig",
          purpose:
            "Speichert Ihre Cookie-Einwilligungspräferenzen, um sich an Ihre Auswahl zu erinnern, welche Cookies Sie akzeptieren.",
          duration: "1 Jahr",
        },
        {
          name: "session-id",
          category: "Notwendig",
          purpose:
            "Behält Ihren Sitzungsstatus beim Durchsuchen der Website bei, um eine ordnungsgemäße Funktionalität sicherzustellen.",
          duration: "Nur Sitzung",
        },
        {
          name: "_ga",
          category: "Analytisch",
          purpose:
            "Google Analytics-Cookie, das eindeutige Benutzer unterscheidet und Einblicke in Website-Nutzungsmuster bietet.",
          duration: "2 Jahre",
        },
        {
          name: "_ga_*",
          category: "Analytisch",
          purpose:
            "Google Analytics 4-Cookie, das Informationen darüber sammelt, wie Sie mit unserer Website interagieren.",
          duration: "2 Jahre",
        },
      ],
      managingTitle: "Verwaltung Ihrer Cookie-Präferenzen",
      managingText:
        'Sie können Ihre Cookie-Präferenzen jederzeit verwalten, indem Sie auf den Link "Cookie-Einstellungen" in unserer Website-Fußzeile klicken oder die Einstellungen Ihres Browsers verwenden, um Cookies zu blockieren oder zu löschen. Bitte beachten Sie, dass die Deaktivierung wesentlicher Cookies die Funktionalität unserer Website beeinträchtigen kann.',
    },
    yourRightsContent: {
      intro: "Sie können jederzeit die folgenden Rechte ausüben, die von der DSGVO vorgesehen sind:",
      rights: [
        'Recht zu wissen, welche Ihrer personenbezogenen Daten über unsere Plattform verarbeitet werden und auf welche Weise, Recht auf Erhalt von Kopien dieser Daten sowie alle anderen Informationen bezüglich der Verarbeitung ("Recht auf Information und Zugang").',
        "Recht auf Berichtigung, d.h. Recht auf Anforderung der Korrektur und/oder Vervollständigung unrichtiger oder unvollständiger Daten, z.B. wenn Sie Ihre E-Mail-Adresse ändern, fordern Sie an, dass wir sie durch die neue Adresse ersetzen.",
        "Recht auf Löschung der Daten ('Recht auf Vergessenwerden') und/oder Recht auf Einschränkung der Verarbeitung, wenn sie nicht mehr erforderlich ist oder wenn sie nicht im Einklang mit dem Gesetz erfolgt oder wenn die Löschung gesetzlich vorgeschrieben ist.",
        "Recht auf Einschränkung der Verarbeitung, d.h. Recht darauf zu verlangen, dass die Verarbeitung für die Dauer Ihres Antrags auf Berichtigung oder Löschung eingeschränkt wird.",
        "Recht auf Datenübertragbarkeit, d.h. das Recht, Ihre Daten in einem lesbaren elektronischen Format zu erhalten und die Übermittlung dieser Daten durch uns an Dritte zu verlangen, die Sie angeben werden.",
        "Recht auf Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten.",
      ],
      contactTitle: "Kontaktinformationen",
      contactText1:
        "Um Ihre oben genannten Rechte auszuüben und für jegliche Kommunikation bezüglich Ihrer personenbezogenen Daten können Sie per E-Mail an dpo@vidavo.eu, z.Hd. Paraskevi Katsouli oder telefonisch unter +302310474762 kommunizieren.",
      contactText2:
        "Sollten Sie außerdem das Gefühl haben, dass Ihre personenbezogenen Daten in irgendeiner Weise kompromittiert sind, haben Sie das Recht, eine Beschwerde bei der Datenschutzbehörde einzureichen (1-3 Kifissias Av., 11523 Athen, 210 6475600, contact@dpa.gr).",
    },
    purposesAndLegalBasisContent: {
      paragraph1:
        "Der Zweck der Aufzeichnung der IP-Adresse und der Verarbeitung der Daten aus den Dateiprotokollen und dem obligatorischen Cookie ist die Funktion unserer Website sowie der Umgang mit möglichen technischen Problemen und der Schutz unserer Website vor potenziell böswilliger oder illegaler Nutzung (z.B. durch die Aufzeichnung von IP-Adressen). Die Rechtsgrundlage für die obige Verarbeitung ist unser berechtigtes Interesse am Schutz der Sicherheit und Integrität unserer Website.",
      paragraph2:
        "Die Verarbeitung der Daten aus den freiwilligen Cookies zielt darauf ab, die Website durch die Extraktion und Analyse statistischer Daten zu verwalten, zu analysieren und zu aktualisieren, die sich auf die Anzahl unserer Besucher, die Häufigkeit, mit der jeder Besucher uns besucht, ihre geografische Herkunft, die Sprache, die sie auf unserer Website bevorzugen, und welche Seiten sie häufiger besuchen, beziehen, um das Verhalten der Benutzer zu bewerten (z.B. zum Zweck der Verhaltenswerbung). Die betreffende Verarbeitung basiert auf Ihrer Einwilligung, d.h. der Aktivierung jedes Cookies, wenn Sie unsere Website betreten, die Sie jederzeit auf die gleiche Weise widerrufen können, indem Sie die gewünschten Cookies deaktivieren.",
    },
    thirdPartyLinksContent:
      "Die Website verweist auf Websites Dritter, die möglicherweise weitere Verarbeitungen der Daten ihrer Besucher/Benutzer durchführen, verschiedene Cookies verwenden usw. Vidavo übernimmt keine Verantwortung für diese Websites, und für alle relevanten Angelegenheiten müssen Sie sich an die jeweiligen Eigentümer wenden.",
    revisionsContent:
      "Vor jeder potenziellen Änderung der Verarbeitung personenbezogener Daten über die Website werden wir diese Richtlinie entsprechend ändern und anzeigen, damit Sie die relevanten Informationen erhalten und Ihre Rechte wirksam ausüben können.",
    periodOfStorageContent: {
      ipAddress:
        "Die IP-Adresse Ihres Geräts (PC, Handy oder Tablet), die automatisch auf unserem Server gespeichert wird, wenn Sie unsere Website betreten, wird drei Monate lang ab dem Zeitpunkt gespeichert, an dem Sie die Website betreten, und danach automatisch gelöscht.",
      sessionCookies:
        'Die Session-Cookies werden gelöscht, wenn Sie offline gehen oder Ihren Browser schließen. Was "optionale" Cookies betrifft, werden diese für den in der obigen Tabelle genannten Zeitraum gespeichert.',
      emailData:
        "Daten, die Sie uns zur Verfügung stellen, um uns per E-Mail zu kontaktieren (Ihre E-Mail, möglicherweise Ihr Name und Telefonnummer), werden so lange gespeichert, wie es notwendig ist, damit wir auf Ihre Anfragen antworten können, und wenn die Speicherung nicht mehr erforderlich ist, löschen wir die Daten oder reduzieren ihre Verarbeitung, sofern wir nicht gesetzlich verpflichtet sind, die Daten aufzubewahren.",
      claimsData:
        "Im Falle eines Anspruchs (gerichtlich oder außergerichtlich) werden die Daten bis zur endgültigen und unanfechtbaren Beilegung der Ansprüche oder bis zu ihrer Verjährung aufbewahrt.",
    },
    informationSecurityPolicyContent: {
      intro:
        "VIDAVO S.A. reagiert auf die Anforderungen der modernen Geschäftswirklichkeit und zielt auf den Schutz der verwalteten Informationen ab, wobei sie stets auf den ununterbrochenen und vorbildlichen Service für ihre Kunden durch die Aufrechterhaltung der Vertraulichkeit, Verfügbarkeit und Integrität von Informationen abzielt. Sie hat beschlossen, ein Informationssicherheits-Managementsystem in Übereinstimmung mit den Anforderungen der internationalen Norm ISO 27001:2022 zu entwerfen und zu installieren.",
      coversTitle: "Das Informationssicherheits-Managementsystem des Unternehmens umfasst:",
      coversList: [
        "Design, Entwicklung und Produktion von Software zum Empfangen, Verarbeiten und Übertragen medizinischer Signale und Informationen",
        "Schulung in der Verwendung von Software zum Empfangen, Verarbeiten und Übertragen medizinischer Signale und Informationen",
        "Technischer Support von Software zum Empfangen, Verarbeiten und Übertragen medizinischer Signale und Informationen",
        "Vertrieb von Medizinprodukten zur Überwachung und Messung physiologischer Parameter und deren Verbrauchsmaterialien",
      ],
      objectivesTitle: "Hauptziele:",
      objectivesList: [
        "Gewährleistung der Vertraulichkeit, Integrität und Verfügbarkeit der verwalteten Informationen, einschließlich personenbezogener Daten",
        "Gewährleistung des ordnungsgemäßen Funktionierens der Informationssysteme",
        "Die rechtzeitige Reaktion auf Vorfälle, die den Geschäftsbetrieb gefährden könnten",
        "Erfüllung gesetzlicher und behördlicher Anforderungen",
        "Die kontinuierliche Verbesserung des Informationssicherheitsniveaus",
      ],
      managingDirector: "Geschäftsführerin",
      name: "Markella Psymarnou",
      date: "Thessaloniki, 13/09/2024",
    },
    antiBriberyPolicyContent: {
      policySummary: {
        title: "Richtlinienzusammenfassung",
        intro:
          "VIDAVO S.A. verpflichtet sich, ihre Geschäfte gemäß den höchsten ethischen Standards zu führen und verbietet alle Formen von Bestechung und Korruption. Diese Anti-Korruptionsrichtlinie verbietet die Bestechung von Regierungsbeamten sowie die Bestechung im privaten Sektor, einschließlich des Angebots, Versprechens, der Genehmigung oder Bereitstellung von etwas von Wert an jeden Kunden, Geschäftspartner, Lieferanten oder andere Dritte, um eine unsachgemäße Leistung einer mit unserem Geschäft verbundenen Aktivität zu veranlassen oder zu belohnen. Ein Verstoß gegen diese Richtlinie kann zu disziplinarischen Maßnahmen führen, einschließlich, aber nicht beschränkt auf die Beendigung des Arbeitsverhältnisses. Es ist entscheidend, dass Sie nicht nur die Bedeutung dieser Richtlinie verstehen und schätzen, sondern dass Sie sie in Ihrer täglichen Arbeit einhalten. Wenn Sie Fragen zu dieser Richtlinie oder zu geltenden Anti-Korruptionsgesetzen im Allgemeinen haben, wenden Sie sich bitte an den Anti-Korruptionssystem-Manager unter compliance@vidavo.eu.",
        conjunction:
          "In Verbindung mit dieser Richtlinie verweisen Sie bitte auf die Anti-Korruptions-Verfahrensdokumente für zusätzliche Informationen und Details.",
      },
      purposeAndObjectives: {
        title: "Zweck und Ziele der Richtlinie",
        content:
          "Diese Richtlinie soll die mit Bestechung und Korruption verbundenen Risiken des Unternehmens beschreiben, Ihre Verantwortlichkeiten gemäß relevanten Anti-Korruptionsgesetzen und Unternehmensrichtlinien hervorheben und Ihnen die notwendigen Werkzeuge und Unterstützung bieten, um diese Anti-Korruptionsrisiken zu identifizieren und zu bekämpfen.",
      },
      risksAndConsequences: {
        title: "Risiken und/oder Folgen der Nichteinhaltung",
        content:
          "Die Verletzung relevanter Anti-Korruptionsgesetze kann zu schweren zivil- und strafrechtlichen Sanktionen und Schäden am Ruf unseres Unternehmens führen. Unternehmensangestellte, die gegen diese Gesetze verstoßen, können auch schwere zivil- und strafrechtliche Sanktionen, einschließlich Gefängnisstrafen, erleiden. Ein Verstoß gegen diese Richtlinie kann zu disziplinarischen Maßnahmen führen, einschließlich, aber nicht beschränkt auf die Beendigung des Arbeitsverhältnisses.",
      },
      scopeAndRange: {
        title: "Umfang und Anwendungsbereich",
        content:
          "Das Unternehmen erwartet von allen Mitarbeitern, Führungskräften, Direktoren und Dritten, die in seinem Namen arbeiten, dass sie sich jeder Form von Bestechung oder Korruption enthalten, unabhängig von Nationalität, Wohnsitz oder Standort. Zusätzlich zu diesem allgemeinen Verbot von Bestechung und Korruption legen diese Richtlinie und Verfahrensdokumente mehrere Richtlinien- und Verfahrensanforderungen fest, die für alle Mitarbeiter gelten.",
      },
      policyDetails: {
        title: "Richtliniendetails",
        applicableLaws: {
          title: "4.1 Anwendbare Gesetze",
          content:
            "Unternehmensangestellte müssen alle anwendbaren Anti-Korruptionsgesetze einhalten. Diese Gesetze verbieten im Allgemeinen sowohl die Bestechung von Regierungsbeamten als auch die Bestechung im privaten Sektor.",
        },
        prohibitionOfBribery: {
          title: "4.2 Verbot der Bestechung",
          governmentBribery: {
            title: "4.2.1 Regierungsbestechung",
            content:
              "Das Unternehmen und seine Mitarbeiter sind daran gehindert, irgendetwas von Wert an einen Regierungsbeamten zu geben, zu versprechen, anzubieten oder die Zahlung zu autorisieren, um Geschäfte zu erhalten oder zu behalten, jeden anderen unsachgemäßen Vorteil zu sichern oder die Handlungen eines Regierungsbeamten unsachgemäß zu beeinflussen. Darüber hinaus sollten Unternehmensassociierte auch unangemessene Interaktionen mit Regierungsbeamten vermeiden.",
          },
          commercialBribery: {
            title: "4.2.2 Kommerzielle Bestechung",
            content:
              'Zusätzlich zu den oben diskutierten Verboten der Bestechung von Regierungsbeamten verbietet das Unternehmen den Mitarbeitern, Zahlungen und andere Vorteile an private Personen und Einheiten anzubieten oder bereitzustellen oder diese von ihnen anzunehmen. Solche Zahlungen stellen kommerzielle Bestechung dar und werden oft als \\"Schmiergelder\\" bezeichnet.',
          },
          facilitationPayments: {
            title: "4.2.3 Erleichterungszahlungen",
            content:
              'Das Bestechungsverbot des Unternehmens gilt für alle unsachgemäßen Zahlungen unabhängig von Größe oder Zweck, einschließlich \\"Erleichterungs\\"- (oder Beschleunigungs-)Zahlungen. Erleichterungszahlungen beziehen sich auf kleine Zahlungen an Regierungsbeamte, um Maßnahmen oder Dienstleistungen zu beschleunigen oder zu erleichtern, wie z.B. die Erlangung einer Lizenz, die Bearbeitung von Regierungsdokumenten wie Visa, die Zollabfertung, die Bereitstellung von Telefon-, Strom- oder Wasserversorgung oder das Be- oder Entladen von Fracht. Im Allgemeinen sind Erleichterungszahlungen durch diese Richtlinie verboten.',
          },
        },
        provisionOfItems: {
          title: "4.3 Bereitstellung von Wertgegenständen an Regierungsbeamte",
          governmentTransactionApproval: {
            title: "4.3.1 Genehmigungstool für Regierungstransaktionen",
            content:
              "Bevor einem Regierungsbeamten oder einer Regierungsbehörde etwas von Wert zur Verfügung gestellt wird, müssen die Mitarbeiter zunächst die schriftliche Genehmigung des Rechtsberaters des Unternehmens einholen.",
          },
          giftsMealsTravel: {
            title: "4.3.2 Geschenke, Mahlzeiten, Reisen und Unterhaltung",
            content:
              "Keine Geschenke, Mahlzeiten, Reisen oder Unterhaltungen dürfen jemandem (Regierungsbeamten oder Geschäftspartnern) im Austausch für eine unsachgemäße Gefälligkeit oder einen Vorteil gegeben werden. Darüber hinaus sind Geschenke in bar oder Bargeldäquivalente, wie Geschenkkarten, nicht erlaubt.",
          },
          gifts: {
            title: "4.3.3 Geschenke",
            content:
              "Kein Geschenk darf gegeben werden, um einen Regierungsbeamten unsachgemäß zu beeinflussen oder im Austausch für eine unsachgemäße Gefälligkeit oder einen Vorteil. Es kann jedoch zulässig sein, Spenden direkt an eine Regierungsbehörde (statt an einen einzelnen Regierungsbeamten) im Rahmen einer wohltätigen Bemühung zu machen.",
          },
          promotionDemonstration: {
            title: "4.3.4 Werbung, Demonstration oder Erklärung von Produkten",
            content:
              "Keine Werbeausgaben oder -aktivitäten dürfen an einen Regierungsbeamten gerichtet werden, um ihn oder sie unsachgemäß zu beeinflussen oder als Gegenleistung für eine unsachgemäße Gefälligkeit oder einen Vorteil. Unter bestimmten Umständen kann es jedoch angemessen sein, solche Ausgaben an einen Regierungsbeamten oder eine Regierungsbehörde zu richten, um die Produkte und Dienstleistungen des Unternehmens zu bewerben, zu demonstrieren oder zu erklären.",
          },
          hiringGovernmentOfficials: {
            title: "4.3.5 Einstellung oder Beschäftigung von Regierungsbeamten",
            content:
              "Kein Regierungsbeamter oder Mitglieder seiner/ihrer unmittelbaren Familie dürfen eingestellt oder beschäftigt werden, um den Mitarbeiter unsachgemäß zu beeinflussen oder als Gegenleistung für eine unsachgemäße Gefälligkeit oder einen Vorteil. Bitte beachten Sie, dass vor der Einstellung eines Regierungsbeamten (oder seines/ihres Verwandten) die Mitarbeiter des Unternehmens zunächst eine rechtliche Genehmigung einholen müssen.",
          },
          politicalContributions: {
            title: "4.3.6 Politische Beiträge",
            content:
              "Keine politischen Beiträge dürfen geleistet werden, um einen Regierungsbeamten unsachgemäß zu beeinflussen oder im Austausch für eine unsachgemäße Gefälligkeit oder einen Vorteil.",
          },
        },
        thirdPartyManagement: {
          title: "4.4 Drittparteienverwaltung",
          applicability: {
            title: "4.4.1 Anwendbarkeit auf Dritte",
            paragraph1:
              'Drittagenten, Berater, Distributoren oder andere Drittvertreter, die für oder im Namen des Unternehmens handeln (zusammen \\"Dritte\\"), sind daran gehindert, Korruptionszahlungen im Namen des Unternehmens zu leisten. Dieses Verbot gilt auch für Subunternehmer, die von Dritten beauftragt wurden, Arbeiten im Namen des Unternehmens auszuführen.',
            paragraph2:
              "Alle Zahlungen an Dritte, einschließlich Provisionen, Erstattungen, Rückerstattungen, müssen üblich und angemessen im Verhältnis zu den erbrachten Dienstleistungen sein und müssen in den Büchern und Aufzeichnungen des Unternehmens genau dokumentiert werden. Keine solche Zahlung darf in bar oder auf Bankkonten erfolgen, die nicht auf den Namen des Dritten lauten.",
          },
          dueDiligence: {
            title: "4.4.2 Sorgfaltspflicht",
            paragraph1:
              "Alle Dritten, die im Namen des Unternehmens mit Regierungsbeamten oder -behörden interagieren werden, müssen den Sorgfaltspflichtprozess des Unternehmens abschließen, bevor sie im Namen des Unternehmens zu arbeiten beginnen. Die Verfahrensdokumente bieten einen detaillierten Überblick über den Drittparteien-Sorgfaltspflichtprozess.",
            paragraph2:
              "Alle während einer Lieferanten-Sorgfaltsprüfung aufgeworfenen Warnsignale sollten zur Zufriedenheit des Rechtsberaters des Unternehmens behandelt werden, bevor eine Beziehung mit dem Dritten eingegangen wird, und jede umgesetzte Abhilfemaßnahme sollte im Sorgfaltspflicht-Tool dokumentiert werden. Die Verfahrensdokumente enthalten zusätzliche Informationen zu gängigen Warnsignalen von Dritten. Wichtig ist, dass die Sorgfaltspflicht für aktive Lieferanten alle drei Jahre erneuert werden sollte.",
            paragraph3:
              "Alle Vereinbarungen mit Dritten, die mit Regierungsbehörden oder -beamten interagieren, müssen schriftlich sein und angemessene Anti-Korruptionsformulierungen enthalten. Der Rechtsberater des Unternehmens wird die angemessene vertragliche Formulierung festlegen.",
            paragraph4:
              "Sobald ein Drittagent oder -berater vom Unternehmen erworben wird, müssen die Aktivitäten und Ausgaben des Dritten vom zuständigen Unternehmensbeamten überwacht werden, um die fortgesetzte Einhaltung der geltenden Anti-Korruptionsgesetze und Unternehmensrichtlinien sicherzustellen.",
          },
        },
        education: {
          title: "4.5 Schulung",
          paragraph1:
            "Das Unternehmen verlangt von allen Direktoren und allen Mitarbeitern, alle zwei Jahre eine Anti-Korruptionsschulung abzuschließen.",
          paragraph2:
            "Die erforderliche Anti-Korruptionsschulung kann persönliche oder Online-Schulungen, einen webbasierten Anti-Korruptionsschulungskurs oder von Ausbildern geleitete Schulungsprogramme umfassen. Wenn einem Unternehmensassoziierten ein webbasierter Schulungskurs zugewiesen wird, muss er oder sie diesen webbasierten Kurs abschließen, unabhängig davon, ob er oder sie auch persönliche Schulungen erhalten hat.",
        },
        audit: {
          title: "4.7 Audit",
          content:
            "Unternehmensmitarbeiter führen regelmäßige interne Audits der relevanten Geschäftstätigkeiten des Unternehmens durch, um die fortgesetzte Einhaltung der geltenden Anti-Korruptionsgesetze und dieser Richtlinie durch das Unternehmen sicherzustellen. Es ist die Pflicht aller Mitarbeiter, bei solchen Audit-Aktivitäten oder Untersuchungen des Unternehmens zu kooperieren und diese niemals zu behindern oder zu blockieren. Von den Prüfern des Unternehmens wird erwartet, dass sie unabhängig handeln und den Rechtsberater des Unternehmens zur Klärung von Fragen zur Anwendung dieser Richtlinie kontaktieren.",
        },
        reportingViolations: {
          title: "4.8 Meldung von Verstößen",
          content:
            "Wenn Sie ein Verhalten beobachten, das gegen diese Richtlinie verstoßen könnte, wenden Sie sich an den Rechtsberater des Unternehmens oder verwenden Sie compliance@vidavo.eu. Vermutete Verstöße werden überprüft und angemessen untersucht und können zu disziplinarischen Maßnahmen führen. Jeder solche Bericht wird im gesetzlich zulässigen Umfang als vertraulich behandelt. Das Unternehmen verbietet strikt Vergeltungsmaßnahmen für gutgläubige Meldungen vermuteten Fehlverhaltens. Die Nichtmeldung eines Verstoßes gegen diese Richtlinie stellt einen unabhängigen Verstoß gegen diese Richtlinie dar, der disziplinarische Maßnahmen nach sich ziehen kann, einschließlich, aber nicht beschränkt auf die Beendigung des Arbeitsverhältnisses.",
        },
      },
      managingDirector: "Geschäftsführerin",
      name: "Markella Psymarnou",
    },
  },
  cookies: {
    banner: {
      title: "Wir verwenden Cookies",
      description:
        'Diese Website verwendet Cookies, um Ihr Surferlebnis zu verbessern und personalisierte Inhalte bereitzustellen. Mit einem Klick auf "Alle akzeptieren" stimmen Sie unserer Verwendung von Cookies zu.',
      acceptAll: "Alle akzeptieren",
      necessaryOnly: "Nur notwendige",
      settings: "Einstellungen",
    },
    dialog: {
      title: "Cookie-Einstellungen",
      description:
        "Wählen Sie aus, welche Cookies Sie akzeptieren möchten. Sie können diese Einstellungen jederzeit ändern.",
      necessary: {
        label: "Notwendige Cookies",
        description:
          "Erforderlich, damit die Website ordnungsgemäß funktioniert. Diese Cookies können nicht deaktiviert werden.",
      },
      analytics: {
        label: "Analytische Cookies",
        description: "Helfen uns zu verstehen, wie Besucher unsere Website nutzen",
      },
      cancel: "Abbrechen",
      savePreferences: "Einstellungen speichern",
    },
  },
  common: {
    learnMore: "Mehr erfahren",
  },
  vida24HomeCare: {
    meta: {
      title: "Vida24 für die häusliche Pflege | Telemonitoring für Pflege- und Gesundheitseinrichtungen",
      description: "Vida24 unterstützt Pflegeteams bei der Erfassung von Vitalwerten, der Überwachung des Gesundheitszustands in Echtzeit und der Koordination der Pflege über eine vernetzte Plattform.",
      ogTitle: "Vida24 — Telemonitoring für häusliche Pflege, Pflegeheime und Gesundheitseinrichtungen",
      ogDescription: "Eine vernetzte Plattform für die Erfassung von Vitalwerten, Echtzeit-Monitoring und koordinierte Pflege.",
    },
    hero: {
      titlePrefix: "Telemonitoring für",
      titleItems: ["häusliche Pflege", "Pflegeheime", "Gesundheitseinrichtungen"],
      subtitle: "Vida24 unterstützt Pflegeteams bei der Erfassung von Vitalwerten, der Überwachung des Gesundheitszustands in Echtzeit und der Koordination der Pflege über eine vernetzte Plattform.",
      requestDemo: "Demo anfragen",
    },
    benefits: [
      { title: "Pflege im vertrauten Umfeld", text: "Kontinuierliche Pflege zu Hause und in Pflegeeinrichtungen." },
      { title: "Echtzeit-Monitoring", text: "Erfassen Sie Vitalwerte in Echtzeit und erkennen Sie Veränderungen frühzeitig." },
      { title: "Bessere Ergebnisse & Lebensqualität", text: "Schnellere Reaktion, weniger Eskalationen und bessere Lebensqualität." },
      { title: "Vernetzte & koordinierte Pflege", text: "Pflegeteams, Ärzte und Einrichtungen arbeiten auf einer Plattform zusammen." },
    ],
    howItWorks: {
      title: "So funktioniert Vida24",
      steps: [
        { title: "Messen", text: "Patienten oder Pflegekräfte erfassen Vitalwerte mit vernetzten medizinischen Geräten zu Hause oder in der Pflegeeinrichtung." },
        { title: "Übertragen", text: "Die Daten werden sicher über Bluetooth-Konnektivität an die Vida24-Plattform übertragen." },
        { title: "Dokumentieren", text: "Messwerte werden automatisch dem Patientenakte zugeordnet und sorgen für eine vollständige und genaue Dokumentation." },
        { title: "Überblick", text: "Fachkräfte erhalten über ein zentrales Dashboard sofortige Einsicht in Gesundheitszustand, Trends und Warnmeldungen." },
        { title: "Reagieren", text: "Pflegeteams können schnell reagieren, Interventionen koordinieren und auf Basis von Echtzeitinformationen eine kontinuierliche Versorgung sicherstellen." },
      ],
    },
    devices: {
      title: "Vernetzte medizinische Geräte",
      subtitle: "Vida24 unterstützt die Integration einer breiten Palette von Bluetooth-fähigen medizinischen Geräten für Fernüberwachung und vernetzte Pflege.",
      items: [
        { name: "Blutzuckermessgerät", detail: "Accu-Chek Instant" },
        { name: "Blutdruckmessgerät", detail: "Kontinuierliche Blutdrucküberwachung" },
        { name: "Thermometer", detail: "Körpertemperatur" },
        { name: "Spirometer", detail: "Atemkapazität" },
        { name: "EKG-Gerät", detail: "D-Heart" },
      ],
    },
    capabilities: {
      title: "Plattform-Funktionen",
      items: [
        { title: "Cloud-Dashboard-Lösung", text: "Sicherer Zugriff jederzeit und überall." },
        { title: "Kompatibel mit bestehender Pflegesoftware", text: "Nahtlose Integration in Ihre Arbeitsabläufe." },
        { title: "Kompatibel mit Bluetooth- und Vitalwertgeräten", text: "Zuverlässiges und skalierbares Geräte-Ökosystem." },
      ],
    },
    audiences: {
      title: "Für wen ist Vida24",
      subtitle: "Entwickelt zur Unterstützung von Pflegekräften, Gesundheitsorganisationen und Einzelpersonen durch vernetzte Pflege und Telemonitoring.",
      prev: "Vorherige Zielgruppe",
      next: "Nächste Zielgruppe",
      slide: "Zu Folie wechseln",
      items: [
        { title: "Für Pflegeteams", items: ["Vitalwerte einfach erfassen", "Pflegemaßnahmen koordinieren", "Patienten im Blick behalten"] },
        { title: "Für Leistungserbringer & Organisationen", items: ["Zentraler Patientenüberblick", "Bessere Koordination & Ressourcenverteilung", "Skalierbare Monitoring-Abläufe"] },
        { title: "Für Patienten & Bewohner", items: ["Pflege im vertrauten Umfeld", "Kontinuierliche Monitoring-Unterstützung", "Bessere Verbindung zum Pflegeteam"] },
      ],
    },
    reasons: {
      title: "Warum Organisationen Vida24 wählen",
      items: [
        { title: "Bewährte Telemonitoring-Plattform", text: "Unterstützt vernetzte Pflege und Fernüberwachungs-Workflows." },
        { title: "Vielfältige Geräteintegrationen", text: "Kompatibel mit einer breiten Palette von Bluetooth-fähigen medizinischen Geräten." },
        { title: "Zentrales Pflegemanagement", text: "Eine Plattform für Monitoring, Koordination und Dokumentation." },
        { title: "Skalierbar über alle Pflegeumgebungen", text: "Geeignet für häusliche Pflege, Pflegeheime und Gesundheitseinrichtungen." },
      ],
    },
    cta: {
      title: "Bereit, Vida24 zu entdecken?",
      subtitle: "Lassen Sie uns besprechen, wie vernetzte Pflege und Telemonitoring Ihre Organisation unterstützen können.",
      demo: "Demo anfragen",
      pilot: "Pilotprojekt starten",
      contact: "Kontaktieren Sie uns",
    },
    contactModal: {
      titles: { demo: "Demo anfragen", general: "Allgemeine Anfrage", pilot: "Pilotprojekt" },
      subtitle: "Erfahren Sie, wie Vida24 Ihre Organisation durch vernetzte Pflege und Telemonitoring unterstützen kann.",
      labels: {
        firstName: "Vorname",
        lastName: "Nachname",
        organization: "Organisation",
        jobTitle: "Position",
        country: "Land",
        email: "E-Mail",
        phone: "Telefon",
        message: "Nachricht",
      },
      close: "Formular schließen",
      submit: "Anfrage senden",
    },
  },
};
